! function(e) {
    function t(t) {
        for (var n, l, r = t[0], a = t[1], h = t[2], d = 0, u = []; d < r.length; d++) l = r[d], Object.prototype.hasOwnProperty.call(s, l) && s[l] && u.push(s[l][0]), s[l] = 0;
        for (n in a) Object.prototype.hasOwnProperty.call(a, n) && (e[n] = a[n]);
        for (c && c(t); u.length;) u.shift()();
        return o.push.apply(o, h || []), i()
    }

    function i() {
        for (var e, t = 0; t < o.length; t++) {
            for (var i = o[t], n = !0, r = 1; r < i.length; r++) {
                var a = i[r];
                0 !== s[a] && (n = !1)
            }
            n && (o.splice(t--, 1), e = l(l.s = i[0]))
        }
        return e
    }
    var n = {},
        s = {
            17: 0
        },
        o = [];

    function l(t) {
        if (n[t]) return n[t].exports;
        var i = n[t] = {
            i: t,
            l: !1,
            exports: {}
        };
        return e[t].call(i.exports, i, i.exports, l), i.l = !0, i.exports
    }
    l.m = e, l.c = n, l.d = function(e, t, i) {
        l.o(e, t) || Object.defineProperty(e, t, {
            enumerable: !0,
            get: i
        })
    }, l.r = function(e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(e, "__esModule", {
            value: !0
        })
    }, l.t = function(e, t) {
        if (1 & t && (e = l(e)), 8 & t) return e;
        if (4 & t && "object" == typeof e && e && e.__esModule) return e;
        var i = Object.create(null);
        if (l.r(i), Object.defineProperty(i, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e)
            for (var n in e) l.d(i, n, function(t) {
                return e[t]
            }.bind(null, n));
        return i
    }, l.n = function(e) {
        var t = e && e.__esModule ? function() {
            return e.default
        } : function() {
            return e
        };
        return l.d(t, "a", t), t
    }, l.o = function(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t)
    }, l.p = "";
    var r = window.loftWebpackJsonp = window.loftWebpackJsonp || [],
        a = r.push.bind(r);
    r.push = t, r = r.slice();
    for (var h = 0; h < r.length; h++) t(r[h]);
    var c = a;
    o.push([57, 0]), i()
}({
    17: function(e, t, i) {
        e.exports = function() {
            "use strict";

            function e(t) {
                return (e = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
                })(t)
            }

            function t(e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
            }

            function i(e, t) {
                for (var i = 0; i < t.length; i++) {
                    var n = t[i];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n)
                }
            }

            function n(e, t, n) {
                return t && i(e.prototype, t), n && i(e, n), e
            }

            function s(e) {
                return function(e) {
                    if (Array.isArray(e)) return o(e)
                }(e) || function(e) {
                    if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e)
                }(e) || function(e, t) {
                    if (e) {
                        if ("string" == typeof e) return o(e, t);
                        var i = Object.prototype.toString.call(e).slice(8, -1);
                        return "Object" === i && e.constructor && (i = e.constructor.name), "Map" === i || "Set" === i ? Array.from(e) : "Arguments" === i || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i) ? o(e, t) : void 0
                    }
                }(e) || function() {
                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
                }()
            }

            function o(e, t) {
                (null == t || t > e.length) && (t = e.length);
                for (var i = 0, n = new Array(t); i < t; i++) n[i] = e[i];
                return n
            }
            var l = Date.now();

            function r() {
                var e = {},
                    t = !0,
                    i = 0,
                    n = arguments.length;
                "[object Boolean]" === Object.prototype.toString.call(arguments[0]) && (t = arguments[0], i++);
                for (var s = function(i) {
                        for (var n in i) Object.prototype.hasOwnProperty.call(i, n) && (t && "[object Object]" === Object.prototype.toString.call(i[n]) ? e[n] = r(!0, e[n], i[n]) : e[n] = i[n])
                    }; i < n; i++) {
                    var o = arguments[i];
                    s(o)
                }
                return e
            }

            function a(e, t) {
                if ((_(e) || e === window || e === document) && (e = [e]), z(e) || L(e) || (e = [e]), 0 != P(e))
                    if (z(e) && !L(e))
                        for (var i = e.length, n = 0; n < i && !1 !== t.call(e[n], e[n], n, e); n++);
                    else if (L(e))
                    for (var s in e)
                        if (O(e, s) && !1 === t.call(e[s], e[s], s, e)) break
            }

            function h(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
                    i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
                    n = e[l] = e[l] || [],
                    s = {
                        all: n,
                        evt: null,
                        found: null
                    };
                return t && i && P(n) > 0 && a(n, (function(e, n) {
                    if (e.eventName == t && e.fn.toString() == i.toString()) return s.found = !0, s.evt = n, !1
                })), s
            }

            function c(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                    i = t.onElement,
                    n = t.withCallback,
                    s = t.avoidDuplicate,
                    o = void 0 === s || s,
                    l = t.once,
                    r = void 0 !== l && l,
                    c = t.useCapture,
                    d = void 0 !== c && c,
                    u = arguments.length > 2 ? arguments[2] : void 0,
                    g = i || [];

                function v(e) {
                    T(n) && n.call(u, e, this), r && v.destroy()
                }
                return k(g) && (g = document.querySelectorAll(g)), v.destroy = function() {
                    a(g, (function(t) {
                        var i = h(t, e, v);
                        i.found && i.all.splice(i.evt, 1), t.removeEventListener && t.removeEventListener(e, v, d)
                    }))
                }, a(g, (function(t) {
                    var i = h(t, e, v);
                    (t.addEventListener && o && !i.found || !o) && (t.addEventListener(e, v, d), i.all.push({
                        eventName: e,
                        fn: v
                    }))
                })), v
            }

            function d(e, t) {
                a(t.split(" "), (function(t) {
                    return e.classList.add(t)
                }))
            }

            function u(e, t) {
                a(t.split(" "), (function(t) {
                    return e.classList.remove(t)
                }))
            }

            function g(e, t) {
                return e.classList.contains(t)
            }

            function v(e, t) {
                for (; e !== document.body;) {
                    if (!(e = e.parentElement)) return !1;
                    if ("function" == typeof e.matches ? e.matches(t) : e.msMatchesSelector(t)) return e
                }
            }

            function f(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
                    i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                if (!e || "" === t) return !1;
                if ("none" == t) return T(i) && i(), !1;
                var n = w(),
                    s = t.split(" ");
                a(s, (function(t) {
                    d(e, "g" + t)
                })), c(n, {
                    onElement: e,
                    avoidDuplicate: !1,
                    once: !0,
                    withCallback: function(e, t) {
                        a(s, (function(e) {
                            u(t, "g" + e)
                        })), T(i) && i()
                    }
                })
            }

            function p(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
                if ("" == t) return e.style.webkitTransform = "", e.style.MozTransform = "", e.style.msTransform = "", e.style.OTransform = "", e.style.transform = "", !1;
                e.style.webkitTransform = t, e.style.MozTransform = t, e.style.msTransform = t, e.style.OTransform = t, e.style.transform = t
            }

            function m(e) {
                e.style.display = "block"
            }

            function y(e) {
                e.style.display = "none"
            }

            function b(e) {
                var t = document.createDocumentFragment(),
                    i = document.createElement("div");
                for (i.innerHTML = e; i.firstChild;) t.appendChild(i.firstChild);
                return t
            }

            function x() {
                return {
                    width: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
                    height: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
                }
            }

            function w() {
                var e, t = document.createElement("fakeelement"),
                    i = {
                        animation: "animationend",
                        OAnimation: "oAnimationEnd",
                        MozAnimation: "animationend",
                        WebkitAnimation: "webkitAnimationEnd"
                    };
                for (e in i)
                    if (void 0 !== t.style[e]) return i[e]
            }

            function S(e, t, i, n) {
                if (e()) t();
                else {
                    var s;
                    i || (i = 100);
                    var o = setInterval((function() {
                        e() && (clearInterval(o), s && clearTimeout(s), t())
                    }), i);
                    n && (s = setTimeout((function() {
                        clearInterval(o)
                    }), n))
                }
            }

            function E(e, t, i) {
                if (I(e)) console.error("Inject assets error");
                else if (T(t) && (i = t, t = !1), k(t) && t in window) T(i) && i();
                else {
                    var n;
                    if (-1 !== e.indexOf(".css")) {
                        if ((n = document.querySelectorAll('link[href="' + e + '"]')) && n.length > 0) return void(T(i) && i());
                        var s = document.getElementsByTagName("head")[0],
                            o = s.querySelectorAll('link[rel="stylesheet"]'),
                            l = document.createElement("link");
                        return l.rel = "stylesheet", l.type = "text/css", l.href = e, l.media = "all", o ? s.insertBefore(l, o[0]) : s.appendChild(l), void(T(i) && i())
                    }
                    if ((n = document.querySelectorAll('script[src="' + e + '"]')) && n.length > 0) {
                        if (T(i)) {
                            if (k(t)) return S((function() {
                                return void 0 !== window[t]
                            }), (function() {
                                i()
                            })), !1;
                            i()
                        }
                    } else {
                        var r = document.createElement("script");
                        r.type = "text/javascript", r.src = e, r.onload = function() {
                            if (T(i)) {
                                if (k(t)) return S((function() {
                                    return void 0 !== window[t]
                                }), (function() {
                                    i()
                                })), !1;
                                i()
                            }
                        }, document.body.appendChild(r)
                    }
                }
            }

            function C() {
                return "navigator" in window && window.navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(Android)|(PlayBook)|(BB10)|(BlackBerry)|(Opera Mini)|(IEMobile)|(webOS)|(MeeGo)/i)
            }

            function T(e) {
                return "function" == typeof e
            }

            function k(e) {
                return "string" == typeof e
            }

            function _(e) {
                return !(!e || !e.nodeType || 1 != e.nodeType)
            }

            function A(e) {
                return Array.isArray(e)
            }

            function z(e) {
                return e && e.length && isFinite(e.length)
            }

            function L(t) {
                return "object" === e(t) && null != t && !T(t) && !A(t)
            }

            function I(e) {
                return null == e
            }

            function O(e, t) {
                return null !== e && hasOwnProperty.call(e, t)
            }

            function P(e) {
                if (L(e)) {
                    if (e.keys) return e.keys().length;
                    var t = 0;
                    for (var i in e) O(e, i) && t++;
                    return t
                }
                return e.length
            }

            function M(e) {
                return !isNaN(parseFloat(e)) && isFinite(e)
            }

            function B(e) {
                if (e.events.hasOwnProperty("keyboard")) return !1;
                e.events.keyboard = c("keydown", {
                    onElement: window,
                    withCallback: function(t, i) {
                        var n = (t = t || window.event).keyCode;
                        if (9 == n) {
                            var o = !(!document.activeElement || !document.activeElement.nodeName) && document.activeElement.nodeName.toLocaleLowerCase();
                            if ("input" == o || "textarea" == o || "button" == o) return;
                            t.preventDefault();
                            var l = document.querySelectorAll(".gbtn");
                            if (!l || l.length <= 0) return;
                            var r = s(l).filter((function(e) {
                                return g(e, "focused")
                            }));
                            if (!r.length) {
                                var a = document.querySelector('.gbtn[tabindex="0"]');
                                return void(a && (a.focus(), d(a, "focused")))
                            }
                            l.forEach((function(e) {
                                return u(e, "focused")
                            }));
                            var h = r[0].getAttribute("tabindex");
                            h = h || "0";
                            var c = parseInt(h) + 1;
                            c > l.length - 1 && (c = "0");
                            var v = document.querySelector('.gbtn[tabindex="'.concat(c, '"]'));
                            v && (v.focus(), d(v, "focused"))
                        }
                        39 == n && e.nextSlide(), 37 == n && e.prevSlide(), 27 == n && e.close()
                    }
                })
            }

            function D(e) {
                return Math.sqrt(e.x * e.x + e.y * e.y)
            }
            var X = function() {
                function e(i) {
                    t(this, e), this.handlers = [], this.el = i
                }
                return n(e, [{
                    key: "add",
                    value: function(e) {
                        this.handlers.push(e)
                    }
                }, {
                    key: "del",
                    value: function(e) {
                        e || (this.handlers = []);
                        for (var t = this.handlers.length; t >= 0; t--) this.handlers[t] === e && this.handlers.splice(t, 1)
                    }
                }, {
                    key: "dispatch",
                    value: function() {
                        for (var e = 0, t = this.handlers.length; e < t; e++) {
                            var i = this.handlers[e];
                            "function" == typeof i && i.apply(this.el, arguments)
                        }
                    }
                }]), e
            }();

            function Y(e, t) {
                var i = new X(e);
                return i.add(t), i
            }
            var q = function() {
                function e(i, n) {
                    t(this, e), this.element = "string" == typeof i ? document.querySelector(i) : i, this.start = this.start.bind(this), this.move = this.move.bind(this), this.end = this.end.bind(this), this.cancel = this.cancel.bind(this), this.element.addEventListener("touchstart", this.start, !1), this.element.addEventListener("touchmove", this.move, !1), this.element.addEventListener("touchend", this.end, !1), this.element.addEventListener("touchcancel", this.cancel, !1), this.preV = {
                        x: null,
                        y: null
                    }, this.pinchStartLen = null, this.zoom = 1, this.isDoubleTap = !1;
                    var s = function() {};
                    this.rotate = Y(this.element, n.rotate || s), this.touchStart = Y(this.element, n.touchStart || s), this.multipointStart = Y(this.element, n.multipointStart || s), this.multipointEnd = Y(this.element, n.multipointEnd || s), this.pinch = Y(this.element, n.pinch || s), this.swipe = Y(this.element, n.swipe || s), this.tap = Y(this.element, n.tap || s), this.doubleTap = Y(this.element, n.doubleTap || s), this.longTap = Y(this.element, n.longTap || s), this.singleTap = Y(this.element, n.singleTap || s), this.pressMove = Y(this.element, n.pressMove || s), this.twoFingerPressMove = Y(this.element, n.twoFingerPressMove || s), this.touchMove = Y(this.element, n.touchMove || s), this.touchEnd = Y(this.element, n.touchEnd || s), this.touchCancel = Y(this.element, n.touchCancel || s), this._cancelAllHandler = this.cancelAll.bind(this), window.addEventListener("scroll", this._cancelAllHandler), this.delta = null, this.last = null, this.now = null, this.tapTimeout = null, this.singleTapTimeout = null, this.longTapTimeout = null, this.swipeTimeout = null, this.x1 = this.x2 = this.y1 = this.y2 = null, this.preTapPosition = {
                        x: null,
                        y: null
                    }
                }
                return n(e, [{
                    key: "start",
                    value: function(e) {
                        if (e.touches) {
                            this.now = Date.now(), this.x1 = e.touches[0].pageX, this.y1 = e.touches[0].pageY, this.delta = this.now - (this.last || this.now), this.touchStart.dispatch(e, this.element), null !== this.preTapPosition.x && (this.isDoubleTap = this.delta > 0 && this.delta <= 250 && Math.abs(this.preTapPosition.x - this.x1) < 30 && Math.abs(this.preTapPosition.y - this.y1) < 30, this.isDoubleTap && clearTimeout(this.singleTapTimeout)), this.preTapPosition.x = this.x1, this.preTapPosition.y = this.y1, this.last = this.now;
                            var t = this.preV;
                            if (e.touches.length > 1) {
                                this._cancelLongTap(), this._cancelSingleTap();
                                var i = {
                                    x: e.touches[1].pageX - this.x1,
                                    y: e.touches[1].pageY - this.y1
                                };
                                t.x = i.x, t.y = i.y, this.pinchStartLen = D(t), this.multipointStart.dispatch(e, this.element)
                            }
                            this._preventTap = !1, this.longTapTimeout = setTimeout(function() {
                                this.longTap.dispatch(e, this.element), this._preventTap = !0
                            }.bind(this), 750)
                        }
                    }
                }, {
                    key: "move",
                    value: function(e) {
                        if (e.touches) {
                            var t = this.preV,
                                i = e.touches.length,
                                n = e.touches[0].pageX,
                                s = e.touches[0].pageY;
                            if (this.isDoubleTap = !1, i > 1) {
                                var o = e.touches[1].pageX,
                                    l = e.touches[1].pageY,
                                    r = {
                                        x: e.touches[1].pageX - n,
                                        y: e.touches[1].pageY - s
                                    };
                                null !== t.x && (this.pinchStartLen > 0 && (e.zoom = D(r) / this.pinchStartLen, this.pinch.dispatch(e, this.element)), e.angle = function(e, t) {
                                    var i = function(e, t) {
                                        var i = D(e) * D(t);
                                        if (0 === i) return 0;
                                        var n = function(e, t) {
                                            return e.x * t.x + e.y * t.y
                                        }(e, t) / i;
                                        return n > 1 && (n = 1), Math.acos(n)
                                    }(e, t);
                                    return function(e, t) {
                                        return e.x * t.y - t.x * e.y
                                    }(e, t) > 0 && (i *= -1), 180 * i / Math.PI
                                }(r, t), this.rotate.dispatch(e, this.element)), t.x = r.x, t.y = r.y, null !== this.x2 && null !== this.sx2 ? (e.deltaX = (n - this.x2 + o - this.sx2) / 2, e.deltaY = (s - this.y2 + l - this.sy2) / 2) : (e.deltaX = 0, e.deltaY = 0), this.twoFingerPressMove.dispatch(e, this.element), this.sx2 = o, this.sy2 = l
                            } else {
                                if (null !== this.x2) {
                                    e.deltaX = n - this.x2, e.deltaY = s - this.y2;
                                    var a = Math.abs(this.x1 - this.x2),
                                        h = Math.abs(this.y1 - this.y2);
                                    (a > 10 || h > 10) && (this._preventTap = !0)
                                } else e.deltaX = 0, e.deltaY = 0;
                                this.pressMove.dispatch(e, this.element)
                            }
                            this.touchMove.dispatch(e, this.element), this._cancelLongTap(), this.x2 = n, this.y2 = s, i > 1 && e.preventDefault()
                        }
                    }
                }, {
                    key: "end",
                    value: function(e) {
                        if (e.changedTouches) {
                            this._cancelLongTap();
                            var t = this;
                            e.touches.length < 2 && (this.multipointEnd.dispatch(e, this.element), this.sx2 = this.sy2 = null), this.x2 && Math.abs(this.x1 - this.x2) > 30 || this.y2 && Math.abs(this.y1 - this.y2) > 30 ? (e.direction = this._swipeDirection(this.x1, this.x2, this.y1, this.y2), this.swipeTimeout = setTimeout((function() {
                                t.swipe.dispatch(e, t.element)
                            }), 0)) : (this.tapTimeout = setTimeout((function() {
                                t._preventTap || t.tap.dispatch(e, t.element), t.isDoubleTap && (t.doubleTap.dispatch(e, t.element), t.isDoubleTap = !1)
                            }), 0), t.isDoubleTap || (t.singleTapTimeout = setTimeout((function() {
                                t.singleTap.dispatch(e, t.element)
                            }), 250))), this.touchEnd.dispatch(e, this.element), this.preV.x = 0, this.preV.y = 0, this.zoom = 1, this.pinchStartLen = null, this.x1 = this.x2 = this.y1 = this.y2 = null
                        }
                    }
                }, {
                    key: "cancelAll",
                    value: function() {
                        this._preventTap = !0, clearTimeout(this.singleTapTimeout), clearTimeout(this.tapTimeout), clearTimeout(this.longTapTimeout), clearTimeout(this.swipeTimeout)
                    }
                }, {
                    key: "cancel",
                    value: function(e) {
                        this.cancelAll(), this.touchCancel.dispatch(e, this.element)
                    }
                }, {
                    key: "_cancelLongTap",
                    value: function() {
                        clearTimeout(this.longTapTimeout)
                    }
                }, {
                    key: "_cancelSingleTap",
                    value: function() {
                        clearTimeout(this.singleTapTimeout)
                    }
                }, {
                    key: "_swipeDirection",
                    value: function(e, t, i, n) {
                        return Math.abs(e - t) >= Math.abs(i - n) ? e - t > 0 ? "Left" : "Right" : i - n > 0 ? "Up" : "Down"
                    }
                }, {
                    key: "on",
                    value: function(e, t) {
                        this[e] && this[e].add(t)
                    }
                }, {
                    key: "off",
                    value: function(e, t) {
                        this[e] && this[e].del(t)
                    }
                }, {
                    key: "destroy",
                    value: function() {
                        return this.singleTapTimeout && clearTimeout(this.singleTapTimeout), this.tapTimeout && clearTimeout(this.tapTimeout), this.longTapTimeout && clearTimeout(this.longTapTimeout), this.swipeTimeout && clearTimeout(this.swipeTimeout), this.element.removeEventListener("touchstart", this.start), this.element.removeEventListener("touchmove", this.move), this.element.removeEventListener("touchend", this.end), this.element.removeEventListener("touchcancel", this.cancel), this.rotate.del(), this.touchStart.del(), this.multipointStart.del(), this.multipointEnd.del(), this.pinch.del(), this.swipe.del(), this.tap.del(), this.doubleTap.del(), this.longTap.del(), this.singleTap.del(), this.pressMove.del(), this.twoFingerPressMove.del(), this.touchMove.del(), this.touchEnd.del(), this.touchCancel.del(), this.preV = this.pinchStartLen = this.zoom = this.isDoubleTap = this.delta = this.last = this.now = this.tapTimeout = this.singleTapTimeout = this.longTapTimeout = this.swipeTimeout = this.x1 = this.x2 = this.y1 = this.y2 = this.preTapPosition = this.rotate = this.touchStart = this.multipointStart = this.multipointEnd = this.pinch = this.swipe = this.tap = this.doubleTap = this.longTap = this.singleTap = this.pressMove = this.touchMove = this.touchEnd = this.touchCancel = this.twoFingerPressMove = null, window.removeEventListener("scroll", this._cancelAllHandler), null
                    }
                }]), e
            }();

            function H(e) {
                var t = function() {
                        var e, t = document.createElement("fakeelement"),
                            i = {
                                transition: "transitionend",
                                OTransition: "oTransitionEnd",
                                MozTransition: "transitionend",
                                WebkitTransition: "webkitTransitionEnd"
                            };
                        for (e in i)
                            if (void 0 !== t.style[e]) return i[e]
                    }(),
                    i = g(e, "gslide-media") ? e : e.querySelector(".gslide-media"),
                    n = e.querySelector(".gslide-description");
                d(i, "greset"), p(i, "translate3d(0, 0, 0)"), c(t, {
                    onElement: i,
                    once: !0,
                    withCallback: function(e, t) {
                        u(i, "greset")
                    }
                }), i.style.opacity = "", n && (n.style.opacity = "")
            }

            function N(e) {
                if (e.events.hasOwnProperty("touch")) return !1;
                var t, i, n, s = x(),
                    o = s.width,
                    l = s.height,
                    r = !1,
                    a = null,
                    h = null,
                    c = null,
                    f = !1,
                    m = 1,
                    y = 1,
                    b = !1,
                    w = !1,
                    S = null,
                    E = null,
                    C = null,
                    T = null,
                    k = 0,
                    _ = 0,
                    A = !1,
                    z = !1,
                    L = {},
                    I = {},
                    O = 0,
                    P = 0,
                    M = document.getElementById("glightbox-slider"),
                    B = document.querySelector(".goverlay"),
                    D = new q(M, {
                        touchStart: function(t) {
                            if (r = !0, (g(t.targetTouches[0].target, "ginner-container") || v(t.targetTouches[0].target, ".gslide-desc") || "a" == t.targetTouches[0].target.nodeName.toLowerCase()) && (r = !1), v(t.targetTouches[0].target, ".gslide-inline") && !g(t.targetTouches[0].target.parentNode, "gslide-inline") && (r = !1), r) {
                                if (I = t.targetTouches[0], L.pageX = t.targetTouches[0].pageX, L.pageY = t.targetTouches[0].pageY, O = t.targetTouches[0].clientX, P = t.targetTouches[0].clientY, a = e.activeSlide, h = a.querySelector(".gslide-media"), n = a.querySelector(".gslide-inline"), c = null, g(h, "gslide-image") && (c = h.querySelector("img")), u(B, "greset"), t.pageX > 20 && t.pageX < window.innerWidth - 20) return;
                                t.preventDefault()
                            }
                        },
                        touchMove: function(s) {
                            if (r && (I = s.targetTouches[0], !b && !w)) {
                                if (n && n.offsetHeight > l) {
                                    var a = L.pageX - I.pageX;
                                    if (Math.abs(a) <= 13) return !1
                                }
                                f = !0;
                                var d, u = s.targetTouches[0].clientX,
                                    g = s.targetTouches[0].clientY,
                                    v = O - u,
                                    m = P - g;
                                if (Math.abs(v) > Math.abs(m) ? (A = !1, z = !0) : (z = !1, A = !0), t = I.pageX - L.pageX, k = 100 * t / o, i = I.pageY - L.pageY, _ = 100 * i / l, A && c && (d = 1 - Math.abs(i) / l, B.style.opacity = d, e.settings.touchFollowAxis && (k = 0)), z && (d = 1 - Math.abs(t) / o, h.style.opacity = d, e.settings.touchFollowAxis && (_ = 0)), !c) return p(h, "translate3d(".concat(k, "%, 0, 0)"));
                                p(h, "translate3d(".concat(k, "%, ").concat(_, "%, 0)"))
                            }
                        },
                        touchEnd: function() {
                            if (r) {
                                if (f = !1, w || b) return C = S, void(T = E);
                                var t = Math.abs(parseInt(_)),
                                    i = Math.abs(parseInt(k));
                                if (!(t > 29 && c)) return t < 29 && i < 25 ? (d(B, "greset"), B.style.opacity = 1, H(h)) : void 0;
                                e.close()
                            }
                        },
                        multipointEnd: function() {
                            setTimeout((function() {
                                b = !1
                            }), 50)
                        },
                        multipointStart: function() {
                            b = !0, m = y || 1
                        },
                        pinch: function(e) {
                            if (!c || f) return !1;
                            b = !0, c.scaleX = c.scaleY = m * e.zoom;
                            var t = m * e.zoom;
                            if (w = !0, t <= 1) return w = !1, t = 1, T = null, C = null, S = null, E = null, void c.setAttribute("style", "");
                            t > 4.5 && (t = 4.5), c.style.transform = "scale3d(".concat(t, ", ").concat(t, ", 1)"), y = t
                        },
                        pressMove: function(e) {
                            if (w && !b) {
                                var t = I.pageX - L.pageX,
                                    i = I.pageY - L.pageY;
                                C && (t += C), T && (i += T), S = t, E = i;
                                var n = "translate3d(".concat(t, "px, ").concat(i, "px, 0)");
                                y && (n += " scale3d(".concat(y, ", ").concat(y, ", 1)")), p(c, n)
                            }
                        },
                        swipe: function(t) {
                            if (!w)
                                if (b) b = !1;
                                else {
                                    if ("Left" == t.direction) {
                                        if (e.index == e.elements.length - 1) return H(h);
                                        e.nextSlide()
                                    }
                                    if ("Right" == t.direction) {
                                        if (0 == e.index) return H(h);
                                        e.prevSlide()
                                    }
                                }
                        }
                    });
                e.events.touch = D
            }
            var W = function() {
                    function e(i, n) {
                        var s = this,
                            o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
                        if (t(this, e), this.img = i, this.slide = n, this.onclose = o, this.img.setZoomEvents) return !1;
                        this.active = !1, this.zoomedIn = !1, this.dragging = !1, this.currentX = null, this.currentY = null, this.initialX = null, this.initialY = null, this.xOffset = 0, this.yOffset = 0, this.img.addEventListener("mousedown", (function(e) {
                            return s.dragStart(e)
                        }), !1), this.img.addEventListener("mouseup", (function(e) {
                            return s.dragEnd(e)
                        }), !1), this.img.addEventListener("mousemove", (function(e) {
                            return s.drag(e)
                        }), !1), this.img.addEventListener("click", (function(e) {
                            return s.slide.classList.contains("dragging-nav") ? (s.zoomOut(), !1) : s.zoomedIn ? void(s.zoomedIn && !s.dragging && s.zoomOut()) : s.zoomIn()
                        }), !1), this.img.setZoomEvents = !0
                    }
                    return n(e, [{
                        key: "zoomIn",
                        value: function() {
                            var e = this.widowWidth();
                            if (!(this.zoomedIn || e <= 768)) {
                                var t = this.img;
                                if (t.setAttribute("data-style", t.getAttribute("style")), t.style.maxWidth = t.naturalWidth + "px", t.style.maxHeight = t.naturalHeight + "px", t.naturalWidth > e) {
                                    var i = e / 2 - t.naturalWidth / 2;
                                    this.setTranslate(this.img.parentNode, i, 0)
                                }
                                this.slide.classList.add("zoomed"), this.zoomedIn = !0
                            }
                        }
                    }, {
                        key: "zoomOut",
                        value: function() {
                            this.img.parentNode.setAttribute("style", ""), this.img.setAttribute("style", this.img.getAttribute("data-style")), this.slide.classList.remove("zoomed"), this.zoomedIn = !1, this.currentX = null, this.currentY = null, this.initialX = null, this.initialY = null, this.xOffset = 0, this.yOffset = 0, this.onclose && "function" == typeof this.onclose && this.onclose()
                        }
                    }, {
                        key: "dragStart",
                        value: function(e) {
                            e.preventDefault(), this.zoomedIn ? ("touchstart" === e.type ? (this.initialX = e.touches[0].clientX - this.xOffset, this.initialY = e.touches[0].clientY - this.yOffset) : (this.initialX = e.clientX - this.xOffset, this.initialY = e.clientY - this.yOffset), e.target === this.img && (this.active = !0, this.img.classList.add("dragging"))) : this.active = !1
                        }
                    }, {
                        key: "dragEnd",
                        value: function(e) {
                            var t = this;
                            e.preventDefault(), this.initialX = this.currentX, this.initialY = this.currentY, this.active = !1, setTimeout((function() {
                                t.dragging = !1, t.img.isDragging = !1, t.img.classList.remove("dragging")
                            }), 100)
                        }
                    }, {
                        key: "drag",
                        value: function(e) {
                            this.active && (e.preventDefault(), "touchmove" === e.type ? (this.currentX = e.touches[0].clientX - this.initialX, this.currentY = e.touches[0].clientY - this.initialY) : (this.currentX = e.clientX - this.initialX, this.currentY = e.clientY - this.initialY), this.xOffset = this.currentX, this.yOffset = this.currentY, this.img.isDragging = !0, this.dragging = !0, this.setTranslate(this.img, this.currentX, this.currentY))
                        }
                    }, {
                        key: "onMove",
                        value: function(e) {
                            if (this.zoomedIn) {
                                var t = e.clientX - this.img.naturalWidth / 2,
                                    i = e.clientY - this.img.naturalHeight / 2;
                                this.setTranslate(this.img, t, i)
                            }
                        }
                    }, {
                        key: "setTranslate",
                        value: function(e, t, i) {
                            e.style.transform = "translate3d(" + t + "px, " + i + "px, 0)"
                        }
                    }, {
                        key: "widowWidth",
                        value: function() {
                            return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
                        }
                    }]), e
                }(),
                j = function() {
                    function e() {
                        var i = this,
                            n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                        t(this, e);
                        var s = n.dragEl,
                            o = n.toleranceX,
                            l = void 0 === o ? 40 : o,
                            r = n.toleranceY,
                            a = void 0 === r ? 65 : r,
                            h = n.slide,
                            c = void 0 === h ? null : h,
                            d = n.instance,
                            u = void 0 === d ? null : d;
                        this.el = s, this.active = !1, this.dragging = !1, this.currentX = null, this.currentY = null, this.initialX = null, this.initialY = null, this.xOffset = 0, this.yOffset = 0, this.direction = null, this.lastDirection = null, this.toleranceX = l, this.toleranceY = a, this.toleranceReached = !1, this.dragContainer = this.el, this.slide = c, this.instance = u, this.el.addEventListener("mousedown", (function(e) {
                            return i.dragStart(e)
                        }), !1), this.el.addEventListener("mouseup", (function(e) {
                            return i.dragEnd(e)
                        }), !1), this.el.addEventListener("mousemove", (function(e) {
                            return i.drag(e)
                        }), !1)
                    }
                    return n(e, [{
                        key: "dragStart",
                        value: function(e) {
                            if (this.slide.classList.contains("zoomed")) this.active = !1;
                            else {
                                "touchstart" === e.type ? (this.initialX = e.touches[0].clientX - this.xOffset, this.initialY = e.touches[0].clientY - this.yOffset) : (this.initialX = e.clientX - this.xOffset, this.initialY = e.clientY - this.yOffset);
                                var t = e.target.nodeName.toLowerCase();
                                e.target.classList.contains("nodrag") || v(e.target, ".nodrag") || -1 !== ["input", "select", "textarea", "button", "a"].indexOf(t) ? this.active = !1 : (e.preventDefault(), (e.target === this.el || "img" !== t && v(e.target, ".gslide-inline")) && (this.active = !0, this.el.classList.add("dragging"), this.dragContainer = v(e.target, ".ginner-container")))
                            }
                        }
                    }, {
                        key: "dragEnd",
                        value: function(e) {
                            var t = this;
                            e && e.preventDefault(), this.initialX = 0, this.initialY = 0, this.currentX = null, this.currentY = null, this.initialX = null, this.initialY = null, this.xOffset = 0, this.yOffset = 0, this.active = !1, this.doSlideChange && (this.instance.preventOutsideClick = !0, "right" == this.doSlideChange && this.instance.prevSlide(), "left" == this.doSlideChange && this.instance.nextSlide()), this.doSlideClose && this.instance.close(), this.toleranceReached || this.setTranslate(this.dragContainer, 0, 0, !0), setTimeout((function() {
                                t.instance.preventOutsideClick = !1, t.toleranceReached = !1, t.lastDirection = null, t.dragging = !1, t.el.isDragging = !1, t.el.classList.remove("dragging"), t.slide.classList.remove("dragging-nav"), t.dragContainer.style.transform = "", t.dragContainer.style.transition = ""
                            }), 100)
                        }
                    }, {
                        key: "drag",
                        value: function(e) {
                            if (this.active) {
                                e.preventDefault(), this.slide.classList.add("dragging-nav"), "touchmove" === e.type ? (this.currentX = e.touches[0].clientX - this.initialX, this.currentY = e.touches[0].clientY - this.initialY) : (this.currentX = e.clientX - this.initialX, this.currentY = e.clientY - this.initialY), this.xOffset = this.currentX, this.yOffset = this.currentY, this.el.isDragging = !0, this.dragging = !0, this.doSlideChange = !1, this.doSlideClose = !1;
                                var t = Math.abs(this.currentX),
                                    i = Math.abs(this.currentY);
                                if (t > 0 && t >= Math.abs(this.currentY) && (!this.lastDirection || "x" == this.lastDirection)) {
                                    this.yOffset = 0, this.lastDirection = "x", this.setTranslate(this.dragContainer, this.currentX, 0);
                                    var n = this.shouldChange();
                                    if (!this.instance.settings.dragAutoSnap && n && (this.doSlideChange = n), this.instance.settings.dragAutoSnap && n) return this.instance.preventOutsideClick = !0, this.toleranceReached = !0, this.active = !1, this.instance.preventOutsideClick = !0, this.dragEnd(null), "right" == n && this.instance.prevSlide(), void("left" == n && this.instance.nextSlide())
                                }
                                if (this.toleranceY > 0 && i > 0 && i >= t && (!this.lastDirection || "y" == this.lastDirection)) {
                                    this.xOffset = 0, this.lastDirection = "y", this.setTranslate(this.dragContainer, 0, this.currentY);
                                    var s = this.shouldClose();
                                    return !this.instance.settings.dragAutoSnap && s && (this.doSlideClose = !0), void(this.instance.settings.dragAutoSnap && s && this.instance.close())
                                }
                            }
                        }
                    }, {
                        key: "shouldChange",
                        value: function() {
                            var e = !1;
                            if (Math.abs(this.currentX) >= this.toleranceX) {
                                var t = this.currentX > 0 ? "right" : "left";
                                ("left" == t && this.slide !== this.slide.parentNode.lastChild || "right" == t && this.slide !== this.slide.parentNode.firstChild) && (e = t)
                            }
                            return e
                        }
                    }, {
                        key: "shouldClose",
                        value: function() {
                            var e = !1;
                            return Math.abs(this.currentY) >= this.toleranceY && (e = !0), e
                        }
                    }, {
                        key: "setTranslate",
                        value: function(e, t, i) {
                            var n = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
                            e.style.transition = n ? "all .2s ease" : "", e.style.transform = "translate3d(".concat(t, "px, ").concat(i, "px, 0)")
                        }
                    }]), e
                }();

            function F(e, t, i, n) {
                var s = e.querySelector(".gslide-media"),
                    o = new Image,
                    l = "gSlideTitle_" + i,
                    r = "gSlideDesc_" + i;
                o.addEventListener("load", (function() {
                    T(n) && n()
                }), !1), o.src = t.href, o.alt = "", "" !== t.title && o.setAttribute("aria-labelledby", l), "" !== t.description && o.setAttribute("aria-describedby", r), s.insertBefore(o, s.firstChild)
            }

            function V(e, t, i, n) {
                var s = this,
                    o = e.querySelector(".ginner-container"),
                    l = "gvideo" + i,
                    r = e.querySelector(".gslide-media"),
                    a = this.getAllPlayers();
                d(o, "gvideo-container"), r.insertBefore(b('<div class="gvideo-wrapper"></div>'), r.firstChild);
                var h = e.querySelector(".gvideo-wrapper");
                E(this.settings.plyr.css, "Plyr");
                var c = t.href,
                    u = location.protocol.replace(":", ""),
                    g = "",
                    v = "",
                    f = !1;
                "file" == u && (u = "http"), r.style.maxWidth = t.width, E(this.settings.plyr.js, "Plyr", (function() {
                    if (c.match(/vimeo\.com\/([0-9]*)/)) {
                        var e = /vimeo.*\/(\d+)/i.exec(c);
                        g = "vimeo", v = e[1]
                    }
                    if (c.match(/(youtube\.com|youtube-nocookie\.com)\/watch\?v=([a-zA-Z0-9\-_]+)/) || c.match(/youtu\.be\/([a-zA-Z0-9\-_]+)/) || c.match(/(youtube\.com|youtube-nocookie\.com)\/embed\/([a-zA-Z0-9\-_]+)/)) {
                        var o = function(e) {
                            return void 0 !== (e = e.replace(/(>|<)/gi, "").split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/))[2] ? e[2].split(/[^0-9a-z_\-]/i)[0] : e
                        }(c);
                        g = "youtube", v = o
                    }
                    if (null !== c.match(/\.(mp4|ogg|webm|mov)$/)) {
                        g = "local";
                        var r = '<video id="' + l + '" ';
                        r += 'style="background:#000; max-width: '.concat(t.width, ';" '), r += 'preload="metadata" ', r += 'x-webkit-airplay="allow" ', r += 'webkit-playsinline="" ', r += "controls ", r += 'class="gvideo-local">';
                        var u = c.toLowerCase().split(".").pop(),
                            p = {
                                mp4: "",
                                ogg: "",
                                webm: ""
                            };
                        for (var m in p[u = "mov" == u ? "mp4" : u] = c, p)
                            if (p.hasOwnProperty(m)) {
                                var y = p[m];
                                t.hasOwnProperty(m) && (y = t[m]), "" !== y && (r += '<source src="'.concat(y, '" type="video/').concat(m, '">'))
                            }
                        f = b(r += "</video>")
                    }
                    var x = f || b('<div id="'.concat(l, '" data-plyr-provider="').concat(g, '" data-plyr-embed-id="').concat(v, '"></div>'));
                    d(h, "".concat(g, "-video gvideo")), h.appendChild(x), h.setAttribute("data-id", l), h.setAttribute("data-index", i);
                    var w = O(s.settings.plyr, "config") ? s.settings.plyr.config : {},
                        S = new Plyr("#" + l, w);
                    S.on("ready", (function(e) {
                        var t = e.detail.plyr;
                        a[l] = t, T(n) && n()
                    })), S.on("enterfullscreen", Z), S.on("exitfullscreen", Z)
                }))
            }

            function Z(e) {
                var t = v(e.target, ".gslide-media");
                "enterfullscreen" == e.type && d(t, "fullscreen"), "exitfullscreen" == e.type && u(t, "fullscreen")
            }

            function R(e, t, i, n) {
                var s, o = this,
                    l = e.querySelector(".gslide-media"),
                    r = !(!O(t, "href") || !t.href) && t.href.split("#").pop().trim(),
                    a = !(!O(t, "content") || !t.content) && t.content;
                if (a && (k(a) && (s = b('<div class="ginlined-content">'.concat(a, "</div>"))), _(a))) {
                    "none" == a.style.display && (a.style.display = "block");
                    var h = document.createElement("div");
                    h.className = "ginlined-content", h.appendChild(a), s = h
                }
                if (r) {
                    var u = document.getElementById(r);
                    if (!u) return !1;
                    var g = u.cloneNode(!0);
                    g.style.height = t.height, g.style.maxWidth = t.width, d(g, "ginlined-content"), s = g
                }
                if (!s) return console.error("Unable to append inline slide content", t), !1;
                l.style.height = t.height, l.style.width = t.width, l.appendChild(s), this.events["inlineclose" + r] = c("click", {
                    onElement: l.querySelectorAll(".gtrigger-close"),
                    withCallback: function(e) {
                        e.preventDefault(), o.close()
                    }
                }), T(n) && n()
            }

            function G(e, t, i, n) {
                var s = e.querySelector(".gslide-media"),
                    o = function(e) {
                        var t = e.url,
                            i = e.allow,
                            n = e.callback,
                            s = e.appendTo,
                            o = document.createElement("iframe");
                        return o.className = "vimeo-video gvideo", o.src = t, o.style.width = "100%", o.style.height = "100%", i && o.setAttribute("allow", i), o.onload = function() {
                            d(o, "node-ready"), T(n) && n()
                        }, s && s.appendChild(o), o
                    }({
                        url: t.href,
                        callback: n
                    });
                s.parentNode.style.maxWidth = t.width, s.parentNode.style.height = t.height, s.appendChild(o)
            }
            var U = function() {
                    function e() {
                        var i = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                        t(this, e), this.defaults = {
                            href: "",
                            title: "",
                            type: "",
                            description: "",
                            descPosition: "bottom",
                            effect: "",
                            width: "",
                            height: "",
                            content: !1,
                            zoomable: !0,
                            draggable: !0
                        }, L(i) && (this.defaults = r(this.defaults, i))
                    }
                    return n(e, [{
                        key: "sourceType",
                        value: function(e) {
                            var t = e;
                            return null !== (e = e.toLowerCase()).match(/\.(jpeg|jpg|jpe|gif|png|apn|webp|svg)$/) ? "image" : e.match(/(youtube\.com|youtube-nocookie\.com)\/watch\?v=([a-zA-Z0-9\-_]+)/) || e.match(/youtu\.be\/([a-zA-Z0-9\-_]+)/) || e.match(/(youtube\.com|youtube-nocookie\.com)\/embed\/([a-zA-Z0-9\-_]+)/) || e.match(/vimeo\.com\/([0-9]*)/) || null !== e.match(/\.(mp4|ogg|webm|mov)$/) ? "video" : null !== e.match(/\.(mp3|wav|wma|aac|ogg)$/) ? "audio" : e.indexOf("#") > -1 && "" !== t.split("#").pop().trim() ? "inline" : e.indexOf("goajax=true") > -1 ? "ajax" : "external"
                        }
                    }, {
                        key: "parseConfig",
                        value: function(e, t) {
                            var i = this,
                                n = r({
                                    descPosition: t.descPosition
                                }, this.defaults);
                            if (L(e) && !_(e)) {
                                O(e, "type") || (O(e, "content") && e.content ? e.type = "inline" : O(e, "href") && (e.type = this.sourceType(e.href)));
                                var s = r(n, e);
                                return this.setSize(s, t), s
                            }
                            var o = "",
                                l = e.getAttribute("data-glightbox"),
                                h = e.nodeName.toLowerCase();
                            if ("a" === h && (o = e.href), "img" === h && (o = e.src), n.href = o, a(n, (function(s, o) {
                                    O(t, o) && "width" !== o && (n[o] = t[o]);
                                    var l = e.dataset[o];
                                    I(l) || (n[o] = i.sanitizeValue(l))
                                })), n.content && (n.type = "inline"), !n.type && o && (n.type = this.sourceType(o)), I(l)) {
                                if (!n.title && "a" == h) {
                                    var c = e.title;
                                    I(c) || "" === c || (n.title = c)
                                }
                                if (!n.title && "img" == h) {
                                    var d = e.alt;
                                    I(d) || "" === d || (n.title = d)
                                }
                            } else {
                                var u = [];
                                a(n, (function(e, t) {
                                    u.push(";\\s?" + t)
                                })), u = u.join("\\s?:|"), "" !== l.trim() && a(n, (function(e, t) {
                                    var s = l,
                                        o = new RegExp("s?" + t + "s?:s?(.*?)(" + u + "s?:|$)"),
                                        r = s.match(o);
                                    if (r && r.length && r[1]) {
                                        var a = r[1].trim().replace(/;\s*$/, "");
                                        n[t] = i.sanitizeValue(a)
                                    }
                                }))
                            }
                            if (n.description && "." == n.description.substring(0, 1) && document.querySelector(n.description)) n.description = document.querySelector(n.description).innerHTML;
                            else {
                                var g = e.querySelector(".glightbox-desc");
                                g && (n.description = g.innerHTML)
                            }
                            return this.setSize(n, t), this.slideConfig = n, n
                        }
                    }, {
                        key: "setSize",
                        value: function(e, t) {
                            var i = "video" == e.type ? this.checkSize(t.videosWidth) : this.checkSize(t.width),
                                n = this.checkSize(t.height);
                            return e.width = O(e, "width") && "" !== e.width ? this.checkSize(e.width) : i, e.height = O(e, "height") && "" !== e.height ? this.checkSize(e.height) : n, e
                        }
                    }, {
                        key: "checkSize",
                        value: function(e) {
                            return M(e) ? "".concat(e, "px") : e
                        }
                    }, {
                        key: "sanitizeValue",
                        value: function(e) {
                            return "true" !== e && "false" !== e ? e : "true" === e
                        }
                    }]), e
                }(),
                $ = function() {
                    function e(i, n, s) {
                        t(this, e), this.element = i, this.instance = n, this.index = s
                    }
                    return n(e, [{
                        key: "setContent",
                        value: function() {
                            var e = this,
                                t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
                                i = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                            if (g(t, "loaded")) return !1;
                            var n = this.instance.settings,
                                s = this.slideConfig,
                                o = C();
                            T(n.beforeSlideLoad) && n.beforeSlideLoad({
                                index: this.index,
                                slide: t,
                                player: !1
                            });
                            var l = s.type,
                                r = s.descPosition,
                                a = t.querySelector(".gslide-media"),
                                h = t.querySelector(".gslide-title"),
                                c = t.querySelector(".gslide-desc"),
                                u = t.querySelector(".gdesc-inner"),
                                v = i,
                                f = "gSlideTitle_" + this.index,
                                p = "gSlideDesc_" + this.index;
                            if (T(n.afterSlideLoad) && (v = function() {
                                    T(i) && i(), n.afterSlideLoad({
                                        index: e.index,
                                        slide: t,
                                        player: e.instance.getSlidePlayerInstance(e.index)
                                    })
                                }), "" == s.title && "" == s.description ? u && u.parentNode.parentNode.removeChild(u.parentNode) : (h && "" !== s.title ? (h.id = f, h.innerHTML = s.title) : h.parentNode.removeChild(h), c && "" !== s.description ? (c.id = p, o && n.moreLength > 0 ? (s.smallDescription = this.slideShortDesc(s.description, n.moreLength, n.moreText), c.innerHTML = s.smallDescription, this.descriptionEvents(c, s)) : c.innerHTML = s.description) : c.parentNode.removeChild(c), d(a.parentNode, "desc-".concat(r)), d(u.parentNode, "description-".concat(r))), d(a, "gslide-".concat(l)), d(t, "loaded"), "video" !== l) {
                                if ("external" !== l) return "inline" === l ? (R.apply(this.instance, [t, s, this.index, v]), void(n.draggable && new j({
                                    dragEl: t.querySelector(".gslide-inline"),
                                    toleranceX: n.dragToleranceX,
                                    toleranceY: n.dragToleranceY,
                                    slide: t,
                                    instance: this.instance
                                }))) : void("image" !== l ? T(v) && v() : F(t, s, this.index, (function() {
                                    var i = t.querySelector("img");
                                    n.draggable && new j({
                                        dragEl: i,
                                        toleranceX: n.dragToleranceX,
                                        toleranceY: n.dragToleranceY,
                                        slide: t,
                                        instance: e.instance
                                    }), s.zoomable && i.naturalWidth > i.offsetWidth && (d(i, "zoomable"), new W(i, t, (function() {
                                        e.instance.resize()
                                    }))), T(v) && v()
                                })));
                                G.apply(this, [t, s, this.index, v])
                            } else V.apply(this.instance, [t, s, this.index, v])
                        }
                    }, {
                        key: "slideShortDesc",
                        value: function(e) {
                            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 50,
                                i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
                                n = document.createElement("div");
                            n.innerHTML = e;
                            var s = n.innerText,
                                o = i;
                            if ((e = s.trim()).length <= t) return e;
                            var l = e.substr(0, t - 1);
                            return o ? (n = null, l + '... <a href="#" class="desc-more">' + i + "</a>") : l
                        }
                    }, {
                        key: "descriptionEvents",
                        value: function(e, t) {
                            var i = this,
                                n = e.querySelector(".desc-more");
                            if (!n) return !1;
                            c("click", {
                                onElement: n,
                                withCallback: function(e, n) {
                                    e.preventDefault();
                                    var s = document.body,
                                        o = v(n, ".gslide-desc");
                                    if (!o) return !1;
                                    o.innerHTML = t.description, d(s, "gdesc-open");
                                    var l = c("click", {
                                        onElement: [s, v(o, ".gslide-description")],
                                        withCallback: function(e, n) {
                                            "a" !== e.target.nodeName.toLowerCase() && (u(s, "gdesc-open"), d(s, "gdesc-closed"), o.innerHTML = t.smallDescription, i.descriptionEvents(o, t), setTimeout((function() {
                                                u(s, "gdesc-closed")
                                            }), 400), l.destroy())
                                        }
                                    })
                                }
                            })
                        }
                    }, {
                        key: "create",
                        value: function() {
                            return b(this.instance.settings.slideHTML)
                        }
                    }, {
                        key: "getConfig",
                        value: function() {
                            var e = new U(this.instance.settings.slideExtraAttributes);
                            return this.slideConfig = e.parseConfig(this.element, this.instance.settings), this.slideConfig
                        }
                    }]), e
                }(),
                J = C(),
                K = null !== C() || void 0 !== document.createTouch || "ontouchstart" in window || "onmsgesturechange" in window || navigator.msMaxTouchPoints,
                Q = document.getElementsByTagName("html")[0],
                ee = {
                    selector: ".glightbox",
                    elements: null,
                    skin: "clean",
                    theme: "clean",
                    closeButton: !0,
                    startAt: null,
                    autoplayVideos: !0,
                    autofocusVideos: !0,
                    descPosition: "bottom",
                    width: "900px",
                    height: "506px",
                    videosWidth: "960px",
                    beforeSlideChange: null,
                    afterSlideChange: null,
                    beforeSlideLoad: null,
                    afterSlideLoad: null,
                    slideInserted: null,
                    slideRemoved: null,
                    slideExtraAttributes: null,
                    onOpen: null,
                    onClose: null,
                    loop: !1,
                    zoomable: !0,
                    draggable: !0,
                    dragAutoSnap: !1,
                    dragToleranceX: 40,
                    dragToleranceY: 65,
                    preload: !0,
                    oneSlidePerOpen: !1,
                    touchNavigation: !0,
                    touchFollowAxis: !0,
                    keyboardNavigation: !0,
                    closeOnOutsideClick: !0,
                    plugins: !1,
                    plyr: {
                        css: "https://cdn.plyr.io/3.6.3/plyr.css",
                        js: "https://cdn.plyr.io/3.6.3/plyr.js",
                        config: {
                            ratio: "16:9",
                            fullscreen: {
                                enabled: !0,
                                iosNative: !0
                            },
                            youtube: {
                                noCookie: !0,
                                rel: 0,
                                showinfo: 0,
                                iv_load_policy: 3
                            },
                            vimeo: {
                                byline: !1,
                                portrait: !1,
                                title: !1,
                                transparent: !1
                            }
                        }
                    },
                    openEffect: "zoom",
                    closeEffect: "zoom",
                    slideEffect: "slide",
                    moreText: "See more",
                    moreLength: 60,
                    cssEfects: {
                        fade: { in: "fadeIn",
                            out: "fadeOut"
                        },
                        zoom: { in: "zoomIn",
                            out: "zoomOut"
                        },
                        slide: { in: "slideInRight",
                            out: "slideOutLeft"
                        },
                        slideBack: { in: "slideInLeft",
                            out: "slideOutRight"
                        },
                        none: { in: "none",
                            out: "none"
                        }
                    },
                    svg: {
                        close: '<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" xml:space="preserve"><g><g><path d="M505.943,6.058c-8.077-8.077-21.172-8.077-29.249,0L6.058,476.693c-8.077,8.077-8.077,21.172,0,29.249C10.096,509.982,15.39,512,20.683,512c5.293,0,10.586-2.019,14.625-6.059L505.943,35.306C514.019,27.23,514.019,14.135,505.943,6.058z"/></g></g><g><g><path d="M505.942,476.694L35.306,6.059c-8.076-8.077-21.172-8.077-29.248,0c-8.077,8.076-8.077,21.171,0,29.248l470.636,470.636c4.038,4.039,9.332,6.058,14.625,6.058c5.293,0,10.587-2.019,14.624-6.057C514.018,497.866,514.018,484.771,505.942,476.694z"/></g></g></svg>',
                        next: '<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 477.175 477.175" xml:space="preserve"> <g><path d="M360.731,229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1,0s-5.3,13.8,0,19.1l215.5,215.5l-215.5,215.5c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4c3.4,0,6.9-1.3,9.5-4l225.1-225.1C365.931,242.875,365.931,234.275,360.731,229.075z"/></g></svg>',
                        prev: '<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 477.175 477.175" xml:space="preserve"><g><path d="M145.188,238.575l215.5-215.5c5.3-5.3,5.3-13.8,0-19.1s-13.8-5.3-19.1,0l-225.1,225.1c-5.3,5.3-5.3,13.8,0,19.1l225.1,225c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1L145.188,238.575z"/></g></svg>'
                    },
                    slideHTML: '<div class="gslide">\n    <div class="gslide-inner-content">\n        <div class="ginner-container">\n            <div class="gslide-media">\n            </div>\n            <div class="gslide-description">\n                <div class="gdesc-inner">\n                    <h4 class="gslide-title"></h4>\n                    <div class="gslide-desc"></div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>',
                    lightboxHTML: '<div id="glightbox-body" class="glightbox-container">\n    <div class="gloader visible"></div>\n    <div class="goverlay"></div>\n    <div class="gcontainer">\n    <div id="glightbox-slider" class="gslider"></div>\n    <button class="gnext gbtn" tabindex="0" aria-label="Next">{nextSVG}</button>\n    <button class="gprev gbtn" tabindex="1" aria-label="Previous">{prevSVG}</button>\n    <button class="gclose gbtn" tabindex="2" aria-label="Close">{closeSVG}</button>\n</div>\n</div>'
                },
                te = function() {
                    function e() {
                        var i = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                        t(this, e), this.settings = r(ee, i), this.effectsClasses = this.getAnimationClasses(), this.videoPlayers = {}, this.apiEvents = [], this.fullElementsList = !1
                    }
                    return n(e, [{
                        key: "init",
                        value: function() {
                            var e = this,
                                t = this.getSelector();
                            t && (this.baseEvents = c("click", {
                                onElement: t,
                                withCallback: function(t, i) {
                                    t.preventDefault(), e.open(i)
                                }
                            })), this.elements = this.getElements()
                        }
                    }, {
                        key: "open",
                        value: function() {
                            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null,
                                t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                            if (0 == this.elements.length) return !1;
                            this.activeSlide = null, this.prevActiveSlideIndex = null, this.prevActiveSlide = null;
                            var i = M(t) ? t : this.settings.startAt;
                            if (_(e)) {
                                var n = e.getAttribute("data-gallery");
                                n && (this.fullElementsList = this.elements, this.elements = this.getGalleryElements(this.elements, n)), I(i) && (i = this.getElementIndex(e)) < 0 && (i = 0)
                            }
                            M(i) || (i = 0), this.build(), f(this.overlay, "none" == this.settings.openEffect ? "none" : this.settings.cssEfects.fade.in);
                            var s = document.body,
                                o = window.innerWidth - document.documentElement.clientWidth;
                            if (o > 0) {
                                var l = document.createElement("style");
                                l.type = "text/css", l.className = "gcss-styles", l.innerText = ".gscrollbar-fixer {margin-right: ".concat(o, "px}"), document.head.appendChild(l), d(s, "gscrollbar-fixer")
                            }
                            d(s, "glightbox-open"), d(Q, "glightbox-open"), J && (d(document.body, "glightbox-mobile"), this.settings.slideEffect = "slide"), this.showSlide(i, !0), 1 == this.elements.length ? (d(this.prevButton, "glightbox-button-hidden"), d(this.nextButton, "glightbox-button-hidden")) : (u(this.prevButton, "glightbox-button-hidden"), u(this.nextButton, "glightbox-button-hidden")), this.lightboxOpen = !0, this.trigger("open"), T(this.settings.onOpen) && this.settings.onOpen(), K && this.settings.touchNavigation && N(this), this.settings.keyboardNavigation && B(this)
                        }
                    }, {
                        key: "openAt",
                        value: function() {
                            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
                            this.open(null, e)
                        }
                    }, {
                        key: "showSlide",
                        value: function() {
                            var e = this,
                                t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0,
                                i = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                            m(this.loader), this.index = parseInt(t);
                            var n = this.slidesContainer.querySelector(".current");
                            n && u(n, "current"), this.slideAnimateOut();
                            var s = this.slidesContainer.querySelectorAll(".gslide")[t];
                            if (g(s, "loaded")) this.slideAnimateIn(s, i), y(this.loader);
                            else {
                                m(this.loader);
                                var o = this.elements[t],
                                    l = {
                                        index: this.index,
                                        slide: s,
                                        slideNode: s,
                                        slideConfig: o.slideConfig,
                                        slideIndex: this.index,
                                        trigger: o.node,
                                        player: null
                                    };
                                this.trigger("slide_before_load", l), o.instance.setContent(s, (function() {
                                    y(e.loader), e.resize(), e.slideAnimateIn(s, i), e.trigger("slide_after_load", l)
                                }))
                            }
                            this.slideDescription = s.querySelector(".gslide-description"), this.slideDescriptionContained = this.slideDescription && g(this.slideDescription.parentNode, "gslide-media"), this.settings.preload && (this.preloadSlide(t + 1), this.preloadSlide(t - 1)), this.updateNavigationClasses(), this.activeSlide = s
                        }
                    }, {
                        key: "preloadSlide",
                        value: function(e) {
                            var t = this;
                            if (e < 0 || e > this.elements.length - 1) return !1;
                            if (I(this.elements[e])) return !1;
                            var i = this.slidesContainer.querySelectorAll(".gslide")[e];
                            if (g(i, "loaded")) return !1;
                            var n = this.elements[e],
                                s = n.type,
                                o = {
                                    index: e,
                                    slide: i,
                                    slideNode: i,
                                    slideConfig: n.slideConfig,
                                    slideIndex: e,
                                    trigger: n.node,
                                    player: null
                                };
                            this.trigger("slide_before_load", o), "video" == s || "external" == s ? setTimeout((function() {
                                n.instance.setContent(i, (function() {
                                    t.trigger("slide_after_load", o)
                                }))
                            }), 200) : n.instance.setContent(i, (function() {
                                t.trigger("slide_after_load", o)
                            }))
                        }
                    }, {
                        key: "prevSlide",
                        value: function() {
                            this.goToSlide(this.index - 1)
                        }
                    }, {
                        key: "nextSlide",
                        value: function() {
                            this.goToSlide(this.index + 1)
                        }
                    }, {
                        key: "goToSlide",
                        value: function() {
                            var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                            if (this.prevActiveSlide = this.activeSlide, this.prevActiveSlideIndex = this.index, !this.loop() && (e < 0 || e > this.elements.length - 1)) return !1;
                            e < 0 ? e = this.elements.length - 1 : e >= this.elements.length && (e = 0), this.showSlide(e)
                        }
                    }, {
                        key: "insertSlide",
                        value: function() {
                            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                                t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : -1;
                            t < 0 && (t = this.elements.length);
                            var i = new $(e, this, t),
                                n = i.getConfig(),
                                s = r({}, n),
                                o = i.create(),
                                l = this.elements.length - 1;
                            s.index = t, s.node = !1, s.instance = i, s.slideConfig = n, this.elements.splice(t, 0, s);
                            var a = null,
                                h = null;
                            if (this.slidesContainer) {
                                if (t > l) this.slidesContainer.appendChild(o);
                                else {
                                    var c = this.slidesContainer.querySelectorAll(".gslide")[t];
                                    this.slidesContainer.insertBefore(o, c)
                                }(this.settings.preload && 0 == this.index && 0 == t || this.index - 1 == t || this.index + 1 == t) && this.preloadSlide(t), 0 == this.index && 0 == t && (this.index = 1), this.updateNavigationClasses(), a = this.slidesContainer.querySelectorAll(".gslide")[t], h = this.getSlidePlayerInstance(t), s.slideNode = a
                            }
                            this.trigger("slide_inserted", {
                                index: t,
                                slide: a,
                                slideNode: a,
                                slideConfig: n,
                                slideIndex: t,
                                trigger: null,
                                player: h
                            }), T(this.settings.slideInserted) && this.settings.slideInserted({
                                index: t,
                                slide: a,
                                player: h
                            })
                        }
                    }, {
                        key: "removeSlide",
                        value: function() {
                            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : -1;
                            if (e < 0 || e > this.elements.length - 1) return !1;
                            var t = this.slidesContainer && this.slidesContainer.querySelectorAll(".gslide")[e];
                            t && (this.getActiveSlideIndex() == e && (e == this.elements.length - 1 ? this.prevSlide() : this.nextSlide()), t.parentNode.removeChild(t)), this.elements.splice(e, 1), this.trigger("slide_removed", e), T(this.settings.slideRemoved) && this.settings.slideRemoved(e)
                        }
                    }, {
                        key: "slideAnimateIn",
                        value: function(e, t) {
                            var i = this,
                                n = e.querySelector(".gslide-media"),
                                s = e.querySelector(".gslide-description"),
                                o = {
                                    index: this.prevActiveSlideIndex,
                                    slide: this.prevActiveSlide,
                                    slideNode: this.prevActiveSlide,
                                    slideIndex: this.prevActiveSlide,
                                    slideConfig: I(this.prevActiveSlideIndex) ? null : this.elements[this.prevActiveSlideIndex].slideConfig,
                                    trigger: I(this.prevActiveSlideIndex) ? null : this.elements[this.prevActiveSlideIndex].node,
                                    player: this.getSlidePlayerInstance(this.prevActiveSlideIndex)
                                },
                                l = {
                                    index: this.index,
                                    slide: this.activeSlide,
                                    slideNode: this.activeSlide,
                                    slideConfig: this.elements[this.index].slideConfig,
                                    slideIndex: this.index,
                                    trigger: this.elements[this.index].node,
                                    player: this.getSlidePlayerInstance(this.index)
                                };
                            if (n.offsetWidth > 0 && s && (y(s), s.style.display = ""), u(e, this.effectsClasses), t) f(e, this.settings.cssEfects[this.settings.openEffect].in, (function() {
                                i.settings.autoplayVideos && i.slidePlayerPlay(e), i.trigger("slide_changed", {
                                    prev: o,
                                    current: l
                                }), T(i.settings.afterSlideChange) && i.settings.afterSlideChange.apply(i, [o, l])
                            }));
                            else {
                                var r = this.settings.slideEffect,
                                    a = "none" !== r ? this.settings.cssEfects[r].in : r;
                                this.prevActiveSlideIndex > this.index && "slide" == this.settings.slideEffect && (a = this.settings.cssEfects.slideBack.in), f(e, a, (function() {
                                    i.settings.autoplayVideos && i.slidePlayerPlay(e), i.trigger("slide_changed", {
                                        prev: o,
                                        current: l
                                    }), T(i.settings.afterSlideChange) && i.settings.afterSlideChange.apply(i, [o, l])
                                }))
                            }
                            setTimeout((function() {
                                i.resize(e)
                            }), 100), d(e, "current")
                        }
                    }, {
                        key: "slideAnimateOut",
                        value: function() {
                            if (!this.prevActiveSlide) return !1;
                            var e = this.prevActiveSlide;
                            u(e, this.effectsClasses), d(e, "prev");
                            var t = this.settings.slideEffect,
                                i = "none" !== t ? this.settings.cssEfects[t].out : t;
                            this.slidePlayerPause(e), this.trigger("slide_before_change", {
                                prev: {
                                    index: this.prevActiveSlideIndex,
                                    slide: this.prevActiveSlide,
                                    slideNode: this.prevActiveSlide,
                                    slideIndex: this.prevActiveSlideIndex,
                                    slideConfig: I(this.prevActiveSlideIndex) ? null : this.elements[this.prevActiveSlideIndex].slideConfig,
                                    trigger: I(this.prevActiveSlideIndex) ? null : this.elements[this.prevActiveSlideIndex].node,
                                    player: this.getSlidePlayerInstance(this.prevActiveSlideIndex)
                                },
                                current: {
                                    index: this.index,
                                    slide: this.activeSlide,
                                    slideNode: this.activeSlide,
                                    slideIndex: this.index,
                                    slideConfig: this.elements[this.index].slideConfig,
                                    trigger: this.elements[this.index].node,
                                    player: this.getSlidePlayerInstance(this.index)
                                }
                            }), T(this.settings.beforeSlideChange) && this.settings.beforeSlideChange.apply(this, [{
                                index: this.prevActiveSlideIndex,
                                slide: this.prevActiveSlide,
                                player: this.getSlidePlayerInstance(this.prevActiveSlideIndex)
                            }, {
                                index: this.index,
                                slide: this.activeSlide,
                                player: this.getSlidePlayerInstance(this.index)
                            }]), this.prevActiveSlideIndex > this.index && "slide" == this.settings.slideEffect && (i = this.settings.cssEfects.slideBack.out), f(e, i, (function() {
                                var t = e.querySelector(".gslide-media"),
                                    i = e.querySelector(".gslide-description");
                                t.style.transform = "", u(t, "greset"), t.style.opacity = "", i && (i.style.opacity = ""), u(e, "prev")
                            }))
                        }
                    }, {
                        key: "getAllPlayers",
                        value: function() {
                            return this.videoPlayers
                        }
                    }, {
                        key: "getSlidePlayerInstance",
                        value: function(e) {
                            var t = "gvideo" + e,
                                i = this.getAllPlayers();
                            return !(!O(i, t) || !i[t]) && i[t]
                        }
                    }, {
                        key: "stopSlideVideo",
                        value: function(e) {
                            if (_(e)) {
                                var t = e.querySelector(".gvideo-wrapper");
                                t && (e = t.getAttribute("data-index"))
                            }
                            console.log("stopSlideVideo is deprecated, use slidePlayerPause");
                            var i = this.getSlidePlayerInstance(e);
                            i && i.playing && i.pause()
                        }
                    }, {
                        key: "slidePlayerPause",
                        value: function(e) {
                            if (_(e)) {
                                var t = e.querySelector(".gvideo-wrapper");
                                t && (e = t.getAttribute("data-index"))
                            }
                            var i = this.getSlidePlayerInstance(e);
                            i && i.playing && i.pause()
                        }
                    }, {
                        key: "playSlideVideo",
                        value: function(e) {
                            if (_(e)) {
                                var t = e.querySelector(".gvideo-wrapper");
                                t && (e = t.getAttribute("data-index"))
                            }
                            console.log("playSlideVideo is deprecated, use slidePlayerPlay");
                            var i = this.getSlidePlayerInstance(e);
                            i && !i.playing && i.play()
                        }
                    }, {
                        key: "slidePlayerPlay",
                        value: function(e) {
                            if (_(e)) {
                                var t = e.querySelector(".gvideo-wrapper");
                                t && (e = t.getAttribute("data-index"))
                            }
                            var i = this.getSlidePlayerInstance(e);
                            console.log("Player is"), console.log(i), i && !i.playing && (i.play(), this.settings.autofocusVideos && i.elements.container.focus())
                        }
                    }, {
                        key: "setElements",
                        value: function(e) {
                            var t = this;
                            this.settings.elements = !1;
                            var i = [];
                            e && e.length && a(e, (function(e, n) {
                                var s = new $(e, t, n),
                                    o = s.getConfig(),
                                    l = r({}, o);
                                l.slideConfig = o, l.instance = s, l.index = n, i.push(l)
                            })), this.elements = i, this.lightboxOpen && (this.slidesContainer.innerHTML = "", this.elements.length && (a(this.elements, (function() {
                                var e = b(t.settings.slideHTML);
                                t.slidesContainer.appendChild(e)
                            })), this.showSlide(0, !0)))
                        }
                    }, {
                        key: "getElementIndex",
                        value: function(e) {
                            var t = !1;
                            return a(this.elements, (function(i, n) {
                                if (O(i, "node") && i.node == e) return t = n, !0
                            })), t
                        }
                    }, {
                        key: "getElements",
                        value: function() {
                            var e = this,
                                t = [];
                            this.elements = this.elements ? this.elements : [], !I(this.settings.elements) && A(this.settings.elements) && this.settings.elements.length && a(this.settings.elements, (function(i, n) {
                                var s = new $(i, e, n),
                                    o = s.getConfig(),
                                    l = r({}, o);
                                l.node = !1, l.index = n, l.instance = s, l.slideConfig = o, t.push(l)
                            }));
                            var i = !1;
                            return this.getSelector() && (i = document.querySelectorAll(this.getSelector())), i ? (a(i, (function(i, n) {
                                var s = new $(i, e, n),
                                    o = s.getConfig(),
                                    l = r({}, o);
                                l.node = i, l.index = n, l.instance = s, l.slideConfig = o, l.gallery = i.getAttribute("data-gallery"), t.push(l)
                            })), t) : t
                        }
                    }, {
                        key: "getGalleryElements",
                        value: function(e, t) {
                            return e.filter((function(e) {
                                return e.gallery == t
                            }))
                        }
                    }, {
                        key: "getSelector",
                        value: function() {
                            return !this.settings.elements && (this.settings.selector && "data-" == this.settings.selector.substring(0, 5) ? "*[".concat(this.settings.selector, "]") : this.settings.selector)
                        }
                    }, {
                        key: "getActiveSlide",
                        value: function() {
                            return this.slidesContainer.querySelectorAll(".gslide")[this.index]
                        }
                    }, {
                        key: "getActiveSlideIndex",
                        value: function() {
                            return this.index
                        }
                    }, {
                        key: "getAnimationClasses",
                        value: function() {
                            var e = [];
                            for (var t in this.settings.cssEfects)
                                if (this.settings.cssEfects.hasOwnProperty(t)) {
                                    var i = this.settings.cssEfects[t];
                                    e.push("g".concat(i.in)), e.push("g".concat(i.out))
                                }
                            return e.join(" ")
                        }
                    }, {
                        key: "build",
                        value: function() {
                            var e = this;
                            if (this.built) return !1;
                            var t = O(this.settings.svg, "next") ? this.settings.svg.next : "",
                                i = O(this.settings.svg, "prev") ? this.settings.svg.prev : "",
                                n = O(this.settings.svg, "close") ? this.settings.svg.close : "",
                                s = this.settings.lightboxHTML;
                            s = b(s = (s = (s = s.replace(/{nextSVG}/g, t)).replace(/{prevSVG}/g, i)).replace(/{closeSVG}/g, n)), document.body.appendChild(s);
                            var o = document.getElementById("glightbox-body");
                            this.modal = o;
                            var l = o.querySelector(".gclose");
                            this.prevButton = o.querySelector(".gprev"), this.nextButton = o.querySelector(".gnext"), this.overlay = o.querySelector(".goverlay"), this.loader = o.querySelector(".gloader"), this.slidesContainer = document.getElementById("glightbox-slider"), this.events = {}, d(this.modal, "glightbox-" + this.settings.skin), this.settings.closeButton && l && (this.events.close = c("click", {
                                onElement: l,
                                withCallback: function(t, i) {
                                    t.preventDefault(), e.close()
                                }
                            })), l && !this.settings.closeButton && l.parentNode.removeChild(l), this.nextButton && (this.events.next = c("click", {
                                onElement: this.nextButton,
                                withCallback: function(t, i) {
                                    t.preventDefault(), e.nextSlide()
                                }
                            })), this.prevButton && (this.events.prev = c("click", {
                                onElement: this.prevButton,
                                withCallback: function(t, i) {
                                    t.preventDefault(), e.prevSlide()
                                }
                            })), this.settings.closeOnOutsideClick && (this.events.outClose = c("click", {
                                onElement: o,
                                withCallback: function(t, i) {
                                    e.preventOutsideClick || g(document.body, "glightbox-mobile") || v(t.target, ".ginner-container") || v(t.target, ".gbtn") || g(t.target, "gnext") || g(t.target, "gprev") || e.close()
                                }
                            })), a(this.elements, (function(t, i) {
                                e.slidesContainer.appendChild(t.instance.create()), t.slideNode = e.slidesContainer.querySelectorAll(".gslide")[i]
                            })), K && d(document.body, "glightbox-touch"), this.events.resize = c("resize", {
                                onElement: window,
                                withCallback: function() {
                                    e.resize()
                                }
                            }), this.built = !0
                        }
                    }, {
                        key: "resize",
                        value: function() {
                            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                            if ((e = e || this.activeSlide) && !g(e, "zoomed")) {
                                var t = x(),
                                    i = e.querySelector(".gvideo-wrapper"),
                                    n = e.querySelector(".gslide-image"),
                                    s = this.slideDescription,
                                    o = t.width,
                                    l = t.height;
                                if (o <= 768 ? d(document.body, "glightbox-mobile") : u(document.body, "glightbox-mobile"), i || n) {
                                    var r = !1;
                                    if (s && (g(s, "description-bottom") || g(s, "description-top")) && !g(s, "gabsolute") && (r = !0), n)
                                        if (o <= 768) {
                                            var a = n.querySelector("img");
                                            a.setAttribute("style", "")
                                        } else if (r) {
                                        var h = s.offsetHeight,
                                            c = n.querySelector("img");
                                        c.setAttribute("style", "max-height: calc(100vh - ".concat(h, "px)")), s.setAttribute("style", "max-width: ".concat(c.offsetWidth, "px;"))
                                    }
                                    if (i) {
                                        var v = O(this.settings.plyr.config, "ratio") ? this.settings.plyr.config.ratio : "16:9",
                                            f = v.split(":"),
                                            p = 900,
                                            m = p / (parseInt(f[0]) / parseInt(f[1]));
                                        if (m = Math.floor(m), r && (l -= s.offsetHeight), l < m && o > p) {
                                            var y = i.offsetWidth,
                                                b = i.offsetHeight,
                                                w = l / b,
                                                S = {
                                                    width: y * w,
                                                    height: b * w
                                                };
                                            i.parentNode.setAttribute("style", "max-width: ".concat(S.width, "px")), r && s.setAttribute("style", "max-width: ".concat(S.width, "px;"))
                                        } else i.parentNode.style.maxWidth = "".concat(p, "px"), r && s.setAttribute("style", "max-width: ".concat(p, "px;"))
                                    }
                                }
                            }
                        }
                    }, {
                        key: "reload",
                        value: function() {
                            this.init()
                        }
                    }, {
                        key: "updateNavigationClasses",
                        value: function() {
                            var e = this.loop();
                            u(this.nextButton, "disabled"), u(this.prevButton, "disabled"), 0 == this.index && this.elements.length - 1 == 0 ? (d(this.prevButton, "disabled"), d(this.nextButton, "disabled")) : 0 !== this.index || e ? this.index !== this.elements.length - 1 || e || d(this.nextButton, "disabled") : d(this.prevButton, "disabled")
                        }
                    }, {
                        key: "loop",
                        value: function() {
                            var e = O(this.settings, "loopAtEnd") ? this.settings.loopAtEnd : null;
                            return e = O(this.settings, "loop") ? this.settings.loop : e
                        }
                    }, {
                        key: "close",
                        value: function() {
                            var e = this;
                            if (!this.lightboxOpen) {
                                if (this.events) {
                                    for (var t in this.events) this.events.hasOwnProperty(t) && this.events[t].destroy();
                                    this.events = null
                                }
                                return !1
                            }
                            if (this.closing) return !1;
                            this.closing = !0, this.slidePlayerPause(this.activeSlide), this.fullElementsList && (this.elements = this.fullElementsList), d(this.modal, "glightbox-closing"), f(this.overlay, "none" == this.settings.openEffect ? "none" : this.settings.cssEfects.fade.out), f(this.activeSlide, this.settings.cssEfects[this.settings.closeEffect].out, (function() {
                                if (e.activeSlide = null, e.prevActiveSlideIndex = null, e.prevActiveSlide = null, e.built = !1, e.events) {
                                    for (var t in e.events) e.events.hasOwnProperty(t) && e.events[t].destroy();
                                    e.events = null
                                }
                                var i = document.body;
                                u(Q, "glightbox-open"), u(i, "glightbox-open touching gdesc-open glightbox-touch glightbox-mobile gscrollbar-fixer"), e.modal.parentNode.removeChild(e.modal), e.trigger("close"), T(e.settings.onClose) && e.settings.onClose();
                                var n = document.querySelector(".gcss-styles");
                                n && n.parentNode.removeChild(n), e.lightboxOpen = !1, e.closing = null
                            }))
                        }
                    }, {
                        key: "destroy",
                        value: function() {
                            this.close(), this.clearAllEvents(), this.baseEvents && this.baseEvents.destroy()
                        }
                    }, {
                        key: "on",
                        value: function(e, t) {
                            var i = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                            if (!e || !T(t)) throw new TypeError("Event name and callback must be defined");
                            this.apiEvents.push({
                                evt: e,
                                once: i,
                                callback: t
                            })
                        }
                    }, {
                        key: "once",
                        value: function(e, t) {
                            this.on(e, t, !0)
                        }
                    }, {
                        key: "trigger",
                        value: function(e) {
                            var t = this,
                                i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null,
                                n = [];
                            a(this.apiEvents, (function(t, s) {
                                var o = t.evt,
                                    l = t.once,
                                    r = t.callback;
                                o == e && (r(i), l && n.push(s))
                            })), n.length && a(n, (function(e) {
                                return t.apiEvents.splice(e, 1)
                            }))
                        }
                    }, {
                        key: "clearAllEvents",
                        value: function() {
                            this.apiEvents.splice(0, this.apiEvents.length)
                        }
                    }, {
                        key: "version",
                        value: function() {
                            return "3.0.7"
                        }
                    }]), e
                }();
            return function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                    t = new te(e);
                return t.init(), t
            }
        }()
    },
    57: function(e, t, i) {
        "use strict";

        function n(e) {
            return (n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
            })(e)
        }
        i.r(t);
        var s = "object" === ("undefined" == typeof HTMLElement ? "undefined" : n(HTMLElement));

        function o(e) {
            return s ? e instanceof HTMLElement : e && "object" === n(e) && null !== e && 1 === e.nodeType && "string" == typeof e.nodeName
        }

        function l(e, t) {
            t.forEach((function(t) {
                e.classList.add(t)
            }))
        }

        function r(e, t) {
            t.forEach((function(t) {
                e.classList.remove(t)
            }))
        }

        function a() {
            if (!document.querySelector(".drift-base-styles")) {
                var e = document.createElement("style");
                e.type = "text/css", e.classList.add("drift-base-styles"), e.appendChild(document.createTextNode(".drift-bounding-box,.drift-zoom-pane{position:absolute;pointer-events:none}@keyframes noop{0%{zoom:1}}@-webkit-keyframes noop{0%{zoom:1}}.drift-zoom-pane.drift-open{display:block}.drift-zoom-pane.drift-closing,.drift-zoom-pane.drift-opening{animation:noop 1ms;-webkit-animation:noop 1ms}.drift-zoom-pane{overflow:hidden;width:100%;height:100%;top:0;left:0}.drift-zoom-pane-loader{display:none}.drift-zoom-pane img{position:absolute;display:block;max-width:none;max-height:none}"));
                var t = document.head;
                t.insertBefore(e, t.firstChild)
            }
        }

        function h() {
            throw new Error("Missing parameter")
        }

        function c(e, t) {
            for (var i = 0; i < t.length; i++) {
                var n = t[i];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n)
            }
        }
        var d = function() {
            function e(t) {
                ! function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                }(this, e), this.isShowing = !1;
                var i = t.namespace,
                    n = void 0 === i ? null : i,
                    s = t.zoomFactor,
                    o = void 0 === s ? h() : s,
                    l = t.containerEl,
                    r = void 0 === l ? h() : l;
                this.settings = {
                    namespace: n,
                    zoomFactor: o,
                    containerEl: r
                }, this.openClasses = this._buildClasses("open"), this._buildElement()
            }
            var t, i, n;
            return t = e, (i = [{
                key: "_buildClasses",
                value: function(e) {
                    var t = ["drift-".concat(e)],
                        i = this.settings.namespace;
                    return i && t.push("".concat(i, "-").concat(e)), t
                }
            }, {
                key: "_buildElement",
                value: function() {
                    this.el = document.createElement("div"), l(this.el, this._buildClasses("bounding-box"))
                }
            }, {
                key: "show",
                value: function(e, t) {
                    this.isShowing = !0, this.settings.containerEl.appendChild(this.el);
                    var i = this.el.style;
                    i.width = "".concat(Math.round(e / this.settings.zoomFactor), "px"), i.height = "".concat(Math.round(t / this.settings.zoomFactor), "px"), l(this.el, this.openClasses)
                }
            }, {
                key: "hide",
                value: function() {
                    this.isShowing && this.settings.containerEl.removeChild(this.el), this.isShowing = !1, r(this.el, this.openClasses)
                }
            }, {
                key: "setPosition",
                value: function(e, t, i) {
                    var n = window.pageXOffset,
                        s = window.pageYOffset,
                        o = i.left + e * i.width - this.el.clientWidth / 2 + n,
                        l = i.top + t * i.height - this.el.clientHeight / 2 + s;
                    o < i.left + n ? o = i.left + n : o + this.el.clientWidth > i.left + i.width + n && (o = i.left + i.width - this.el.clientWidth + n), l < i.top + s ? l = i.top + s : l + this.el.clientHeight > i.top + i.height + s && (l = i.top + i.height - this.el.clientHeight + s), this.el.style.left = "".concat(o, "px"), this.el.style.top = "".concat(l, "px")
                }
            }]) && c(t.prototype, i), n && c(t, n), e
        }();

        function u(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
        }

        function g(e, t) {
            for (var i = 0; i < t.length; i++) {
                var n = t[i];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n)
            }
        }
        var v = function() {
            function e() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                u(this, e), this._show = this._show.bind(this), this._hide = this._hide.bind(this), this._handleEntry = this._handleEntry.bind(this), this._handleMovement = this._handleMovement.bind(this);
                var i = t.el,
                    n = void 0 === i ? h() : i,
                    s = t.zoomPane,
                    o = void 0 === s ? h() : s,
                    l = t.sourceAttribute,
                    r = void 0 === l ? h() : l,
                    a = t.handleTouch,
                    c = void 0 === a ? h() : a,
                    g = t.onShow,
                    v = void 0 === g ? null : g,
                    f = t.onHide,
                    p = void 0 === f ? null : f,
                    m = t.hoverDelay,
                    y = void 0 === m ? 0 : m,
                    b = t.touchDelay,
                    x = void 0 === b ? 0 : b,
                    w = t.hoverBoundingBox,
                    S = void 0 === w ? h() : w,
                    E = t.touchBoundingBox,
                    C = void 0 === E ? h() : E,
                    T = t.namespace,
                    k = void 0 === T ? null : T,
                    _ = t.zoomFactor,
                    A = void 0 === _ ? h() : _,
                    z = t.boundingBoxContainer,
                    L = void 0 === z ? h() : z;
                this.settings = {
                    el: n,
                    zoomPane: o,
                    sourceAttribute: r,
                    handleTouch: c,
                    onShow: v,
                    onHide: p,
                    hoverDelay: y,
                    touchDelay: x,
                    hoverBoundingBox: S,
                    touchBoundingBox: C,
                    namespace: k,
                    zoomFactor: A,
                    boundingBoxContainer: L
                }, (this.settings.hoverBoundingBox || this.settings.touchBoundingBox) && (this.boundingBox = new d({
                    namespace: this.settings.namespace,
                    zoomFactor: this.settings.zoomFactor,
                    containerEl: this.settings.boundingBoxContainer
                })), this.enabled = !0, this._bindEvents()
            }
            var t, i, n;
            return t = e, (i = [{
                key: "_preventDefault",
                value: function(e) {
                    e.preventDefault()
                }
            }, {
                key: "_preventDefaultAllowTouchScroll",
                value: function(e) {
                    this.settings.touchDelay && this._isTouchEvent(e) && !this.isShowing || e.preventDefault()
                }
            }, {
                key: "_isTouchEvent",
                value: function(e) {
                    return !!e.touches
                }
            }, {
                key: "_bindEvents",
                value: function() {
                    this.settings.el.addEventListener("mouseenter", this._handleEntry, !1), this.settings.el.addEventListener("mouseleave", this._hide, !1), this.settings.el.addEventListener("mousemove", this._handleMovement, !1), this.settings.handleTouch ? (this.settings.el.addEventListener("touchstart", this._handleEntry, !1), this.settings.el.addEventListener("touchend", this._hide, !1), this.settings.el.addEventListener("touchmove", this._handleMovement, !1)) : (this.settings.el.addEventListener("touchstart", this._preventDefault, !1), this.settings.el.addEventListener("touchend", this._preventDefault, !1), this.settings.el.addEventListener("touchmove", this._preventDefault, !1))
                }
            }, {
                key: "_unbindEvents",
                value: function() {
                    this.settings.el.removeEventListener("mouseenter", this._handleEntry, !1), this.settings.el.removeEventListener("mouseleave", this._hide, !1), this.settings.el.removeEventListener("mousemove", this._handleMovement, !1), this.settings.handleTouch ? (this.settings.el.removeEventListener("touchstart", this._handleEntry, !1), this.settings.el.removeEventListener("touchend", this._hide, !1), this.settings.el.removeEventListener("touchmove", this._handleMovement, !1)) : (this.settings.el.removeEventListener("touchstart", this._preventDefault, !1), this.settings.el.removeEventListener("touchend", this._preventDefault, !1), this.settings.el.removeEventListener("touchmove", this._preventDefault, !1))
                }
            }, {
                key: "_handleEntry",
                value: function(e) {
                    this._preventDefaultAllowTouchScroll(e), this._lastMovement = e, "mouseenter" == e.type && this.settings.hoverDelay ? this.entryTimeout = setTimeout(this._show, this.settings.hoverDelay) : this.settings.touchDelay ? this.entryTimeout = setTimeout(this._show, this.settings.touchDelay) : this._show()
                }
            }, {
                key: "_show",
                value: function() {
                    if (this.enabled) {
                        var e = this.settings.onShow;
                        if (e && "function" == typeof e && e(), this.settings.zoomPane.show(this.settings.el.getAttribute(this.settings.sourceAttribute), this.settings.el.clientWidth, this.settings.el.clientHeight), this._lastMovement) {
                            var t = this._lastMovement.touches;
                            (t && this.settings.touchBoundingBox || !t && this.settings.hoverBoundingBox) && this.boundingBox.show(this.settings.zoomPane.el.clientWidth, this.settings.zoomPane.el.clientHeight)
                        }
                        this._handleMovement()
                    }
                }
            }, {
                key: "_hide",
                value: function(e) {
                    e && this._preventDefaultAllowTouchScroll(e), this._lastMovement = null, this.entryTimeout && clearTimeout(this.entryTimeout), this.boundingBox && this.boundingBox.hide();
                    var t = this.settings.onHide;
                    t && "function" == typeof t && t(), this.settings.zoomPane.hide()
                }
            }, {
                key: "_handleMovement",
                value: function(e) {
                    if (e) this._preventDefaultAllowTouchScroll(e), this._lastMovement = e;
                    else {
                        if (!this._lastMovement) return;
                        e = this._lastMovement
                    }
                    var t, i;
                    if (e.touches) {
                        var n = e.touches[0];
                        t = n.clientX, i = n.clientY
                    } else t = e.clientX, i = e.clientY;
                    var s = this.settings.el.getBoundingClientRect(),
                        o = t - s.left,
                        l = i - s.top,
                        r = o / this.settings.el.clientWidth,
                        a = l / this.settings.el.clientHeight;
                    this.boundingBox && this.boundingBox.setPosition(r, a, s), this.settings.zoomPane.setPosition(r, a, s)
                }
            }, {
                key: "isShowing",
                get: function() {
                    return this.settings.zoomPane.isShowing
                }
            }]) && g(t.prototype, i), n && g(t, n), e
        }();

        function f(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
        }

        function p(e, t) {
            for (var i = 0; i < t.length; i++) {
                var n = t[i];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n)
            }
        }
        var m = document.createElement("div").style,
            y = "undefined" != typeof document && ("animation" in m || "webkitAnimation" in m),
            b = function() {
                function e() {
                    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                    f(this, e), this._completeShow = this._completeShow.bind(this), this._completeHide = this._completeHide.bind(this), this._handleLoad = this._handleLoad.bind(this), this.isShowing = !1;
                    var i = t.container,
                        n = void 0 === i ? null : i,
                        s = t.zoomFactor,
                        o = void 0 === s ? h() : s,
                        l = t.inline,
                        r = void 0 === l ? h() : l,
                        a = t.namespace,
                        c = void 0 === a ? null : a,
                        d = t.showWhitespaceAtEdges,
                        u = void 0 === d ? h() : d,
                        g = t.containInline,
                        v = void 0 === g ? h() : g,
                        p = t.inlineOffsetX,
                        m = void 0 === p ? 0 : p,
                        y = t.inlineOffsetY,
                        b = void 0 === y ? 0 : y,
                        x = t.inlineContainer,
                        w = void 0 === x ? document.body : x;
                    this.settings = {
                        container: n,
                        zoomFactor: o,
                        inline: r,
                        namespace: c,
                        showWhitespaceAtEdges: u,
                        containInline: v,
                        inlineOffsetX: m,
                        inlineOffsetY: b,
                        inlineContainer: w
                    }, this.openClasses = this._buildClasses("open"), this.openingClasses = this._buildClasses("opening"), this.closingClasses = this._buildClasses("closing"), this.inlineClasses = this._buildClasses("inline"), this.loadingClasses = this._buildClasses("loading"), this._buildElement()
                }
                var t, i, n;
                return t = e, (i = [{
                    key: "_buildClasses",
                    value: function(e) {
                        var t = ["drift-".concat(e)],
                            i = this.settings.namespace;
                        return i && t.push("".concat(i, "-").concat(e)), t
                    }
                }, {
                    key: "_buildElement",
                    value: function() {
                        this.el = document.createElement("div"), l(this.el, this._buildClasses("zoom-pane"));
                        var e = document.createElement("div");
                        l(e, this._buildClasses("zoom-pane-loader")), this.el.appendChild(e), this.imgEl = document.createElement("img"), this.el.appendChild(this.imgEl)
                    }
                }, {
                    key: "_setImageURL",
                    value: function(e) {
                        this.imgEl.setAttribute("src", e)
                    }
                }, {
                    key: "_setImageSize",
                    value: function(e, t) {
                        this.imgEl.style.width = "".concat(e * this.settings.zoomFactor, "px"), this.imgEl.style.height = "".concat(t * this.settings.zoomFactor, "px")
                    }
                }, {
                    key: "setPosition",
                    value: function(e, t, i) {
                        var n = this.imgEl.offsetWidth,
                            s = this.imgEl.offsetHeight,
                            o = this.el.offsetWidth,
                            l = this.el.offsetHeight,
                            r = o / 2 - n * e,
                            a = l / 2 - s * t,
                            h = o - n,
                            c = l - s,
                            d = h > 0,
                            u = c > 0,
                            g = d ? h / 2 : 0,
                            v = u ? c / 2 : 0,
                            f = d ? h / 2 : h,
                            p = u ? c / 2 : c;
                        if (this.el.parentElement === this.settings.inlineContainer) {
                            var m = window.pageXOffset,
                                y = window.pageYOffset,
                                b = i.left + e * i.width - o / 2 + this.settings.inlineOffsetX + m,
                                x = i.top + t * i.height - l / 2 + this.settings.inlineOffsetY + y;
                            this.settings.containInline && (b < i.left + m ? b = i.left + m : b + o > i.left + i.width + m && (b = i.left + i.width - o + m), x < i.top + y ? x = i.top + y : x + l > i.top + i.height + y && (x = i.top + i.height - l + y)), this.el.style.left = "".concat(b, "px"), this.el.style.top = "".concat(x, "px")
                        }
                        this.settings.showWhitespaceAtEdges || (r > g ? r = g : r < f && (r = f), a > v ? a = v : a < p && (a = p)), this.imgEl.style.transform = "translate(".concat(r, "px, ").concat(a, "px)"), this.imgEl.style.webkitTransform = "translate(".concat(r, "px, ").concat(a, "px)")
                    }
                }, {
                    key: "_removeListenersAndResetClasses",
                    value: function() {
                        this.el.removeEventListener("animationend", this._completeShow, !1), this.el.removeEventListener("animationend", this._completeHide, !1), this.el.removeEventListener("webkitAnimationEnd", this._completeShow, !1), this.el.removeEventListener("webkitAnimationEnd", this._completeHide, !1), r(this.el, this.openClasses), r(this.el, this.closingClasses)
                    }
                }, {
                    key: "show",
                    value: function(e, t, i) {
                        this._removeListenersAndResetClasses(), this.isShowing = !0, l(this.el, this.openClasses), this.imgEl.getAttribute("src") != e && (l(this.el, this.loadingClasses), this.imgEl.addEventListener("load", this._handleLoad, !1), this._setImageURL(e)), this._setImageSize(t, i), this._isInline ? this._showInline() : this._showInContainer(), y && (this.el.addEventListener("animationend", this._completeShow, !1), this.el.addEventListener("webkitAnimationEnd", this._completeShow, !1), l(this.el, this.openingClasses))
                    }
                }, {
                    key: "_showInline",
                    value: function() {
                        this.settings.inlineContainer.appendChild(this.el), l(this.el, this.inlineClasses)
                    }
                }, {
                    key: "_showInContainer",
                    value: function() {
                        this.settings.container.appendChild(this.el)
                    }
                }, {
                    key: "hide",
                    value: function() {
                        this._removeListenersAndResetClasses(), this.isShowing = !1, y ? (this.el.addEventListener("animationend", this._completeHide, !1), this.el.addEventListener("webkitAnimationEnd", this._completeHide, !1), l(this.el, this.closingClasses)) : (r(this.el, this.openClasses), r(this.el, this.inlineClasses))
                    }
                }, {
                    key: "_completeShow",
                    value: function() {
                        this.el.removeEventListener("animationend", this._completeShow, !1), this.el.removeEventListener("webkitAnimationEnd", this._completeShow, !1), r(this.el, this.openingClasses)
                    }
                }, {
                    key: "_completeHide",
                    value: function() {
                        this.el.removeEventListener("animationend", this._completeHide, !1), this.el.removeEventListener("webkitAnimationEnd", this._completeHide, !1), r(this.el, this.openClasses), r(this.el, this.closingClasses), r(this.el, this.inlineClasses), this.el.style = "", this.el.parentElement === this.settings.container ? this.settings.container.removeChild(this.el) : this.el.parentElement === this.settings.inlineContainer && this.settings.inlineContainer.removeChild(this.el)
                    }
                }, {
                    key: "_handleLoad",
                    value: function() {
                        this.imgEl.removeEventListener("load", this._handleLoad, !1), r(this.el, this.loadingClasses)
                    }
                }, {
                    key: "_isInline",
                    get: function() {
                        var e = this.settings.inline;
                        return !0 === e || "number" == typeof e && window.innerWidth <= e
                    }
                }]) && p(t.prototype, i), n && p(t, n), e
            }();

        function x(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
        }

        function w(e, t) {
            for (var i = 0; i < t.length; i++) {
                var n = t[i];
                n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n)
            }
        }
        var S = function() {
            function e(t) {
                var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                if (x(this, e), this.VERSION = "1.4.3", this.triggerEl = t, this.destroy = this.destroy.bind(this), !o(this.triggerEl)) throw new TypeError("`new Drift` requires a DOM element as its first argument.");
                var n = i.namespace || null,
                    s = i.showWhitespaceAtEdges || !1,
                    l = i.containInline || !1,
                    r = i.inlineOffsetX || 0,
                    h = i.inlineOffsetY || 0,
                    c = i.inlineContainer || document.body,
                    d = i.sourceAttribute || "data-zoom",
                    u = i.zoomFactor || 3,
                    g = void 0 === i.paneContainer ? document.body : i.paneContainer,
                    v = i.inlinePane || 375,
                    f = !("handleTouch" in i) || !!i.handleTouch,
                    p = i.onShow || null,
                    m = i.onHide || null,
                    y = !("injectBaseStyles" in i) || !!i.injectBaseStyles,
                    b = i.hoverDelay || 0,
                    w = i.touchDelay || 0,
                    S = i.hoverBoundingBox || !1,
                    E = i.touchBoundingBox || !1,
                    C = i.boundingBoxContainer || document.body;
                if (!0 !== v && !o(g)) throw new TypeError("`paneContainer` must be a DOM element when `inlinePane !== true`");
                if (!o(c)) throw new TypeError("`inlineContainer` must be a DOM element");
                this.settings = {
                    namespace: n,
                    showWhitespaceAtEdges: s,
                    containInline: l,
                    inlineOffsetX: r,
                    inlineOffsetY: h,
                    inlineContainer: c,
                    sourceAttribute: d,
                    zoomFactor: u,
                    paneContainer: g,
                    inlinePane: v,
                    handleTouch: f,
                    onShow: p,
                    onHide: m,
                    injectBaseStyles: y,
                    hoverDelay: b,
                    touchDelay: w,
                    hoverBoundingBox: S,
                    touchBoundingBox: E,
                    boundingBoxContainer: C
                }, this.settings.injectBaseStyles && a(), this._buildZoomPane(), this._buildTrigger()
            }
            var t, i, n;
            return t = e, (i = [{
                key: "_buildZoomPane",
                value: function() {
                    this.zoomPane = new b({
                        container: this.settings.paneContainer,
                        zoomFactor: this.settings.zoomFactor,
                        showWhitespaceAtEdges: this.settings.showWhitespaceAtEdges,
                        containInline: this.settings.containInline,
                        inline: this.settings.inlinePane,
                        namespace: this.settings.namespace,
                        inlineOffsetX: this.settings.inlineOffsetX,
                        inlineOffsetY: this.settings.inlineOffsetY,
                        inlineContainer: this.settings.inlineContainer
                    })
                }
            }, {
                key: "_buildTrigger",
                value: function() {
                    this.trigger = new v({
                        el: this.triggerEl,
                        zoomPane: this.zoomPane,
                        handleTouch: this.settings.handleTouch,
                        onShow: this.settings.onShow,
                        onHide: this.settings.onHide,
                        sourceAttribute: this.settings.sourceAttribute,
                        hoverDelay: this.settings.hoverDelay,
                        touchDelay: this.settings.touchDelay,
                        hoverBoundingBox: this.settings.hoverBoundingBox,
                        touchBoundingBox: this.settings.touchBoundingBox,
                        namespace: this.settings.namespace,
                        zoomFactor: this.settings.zoomFactor,
                        boundingBoxContainer: this.settings.boundingBoxContainer
                    })
                }
            }, {
                key: "setZoomImageURL",
                value: function(e) {
                    this.zoomPane._setImageURL(e)
                }
            }, {
                key: "disable",
                value: function() {
                    this.trigger.enabled = !1
                }
            }, {
                key: "enable",
                value: function() {
                    this.trigger.enabled = !0
                }
            }, {
                key: "destroy",
                value: function() {
                    this.trigger._hide(), this.trigger._unbindEvents()
                }
            }, {
                key: "isShowing",
                get: function() {
                    return this.zoomPane.isShowing
                }
            }, {
                key: "zoomFactor",
                get: function() {
                    return this.settings.zoomFactor
                },
                set: function(e) {
                    this.settings.zoomFactor = e, this.zoomPane.settings.zoomFactor = e, this.trigger.settings.zoomFactor = e, this.boundingBox.settings.zoomFactor = e
                }
            }]) && w(t.prototype, i), n && w(t, n), e
        }();
        Object.defineProperty(S.prototype, "isShowing", {
            get: function() {
                return this.isShowing
            }
        }), Object.defineProperty(S.prototype, "zoomFactor", {
            get: function() {
                return this.zoomFactor
            },
            set: function(e) {
                this.zoomFactor = e
            }
        }), S.prototype.setZoomImageURL = S.prototype.setZoomImageURL, S.prototype.disable = S.prototype.disable, S.prototype.enable = S.prototype.enable, S.prototype.destroy = S.prototype.destroy;
        var E = i(17),
            C = i.n(E),
            T = i(1),
            k = i.n(T);

        function _(e, t) {
            void 0 !== e && (this.zoomTrigger = e, this.zoomElements = t, this.zoomContainerId = this.zoomTrigger.getAttribute("data-zoom-parent"), this.zoomHoverContainer = document.querySelector('[data-zoom-child="' + this.zoomContainerId + '"]'), this.zoomContainerSelector = "[data-zoom-container]", this.currentZoomContainers = [], this.options = {
                sourceAttribute: "data-zoom-gallery",
                showCloseButton: !0
            }, this.galleryOpts = {
                arrowNavigation: !0
            }, this.currentWindowWidth = window.innerWidth, performance.mark("Image Zoom:Start"), this.init(), performance.mark("Image Zoom:End"), performance.measure("Image Zoom", "Image Zoom:Start", "Image Zoom:End"))
        }
        _.prototype = {
            init: function() {
                if (this.listenForImageClicks(this.zoomTrigger), this.zoomGalleryElements = this.buildZoomGallery(this.zoomElements), this.zoomGallery = this.initZoomGallery(this.zoomGalleryElements), this.currentWindowWidth > 1024) {
                    var e = this.zoomHoverContainer.getBoundingClientRect().width + "px";
                    document.documentElement.style.setProperty("--product_image_container_width", e), this.buildZoomHoverEffect(this.zoomElements, this.zoomHoverContainer)
                }
            },
            listenForImageClicks: function(e) {
                k.a.on("click", e, function(e) {
                    if (null !== e.target.closest(".product__image-zoom-img")) {
                        var t = e.target.closest(".product__image-zoom-img").getAttribute("data-zoom-gallery"),
                            i = this.findGalleryIndex(t);
                        this.zoomGallery.openAt(i)
                    }
                }.bind(this))
            },
            buildZoomGallery: function(e) {
                var t = [];
                return e.forEach((function(e) {
                    var i = e.getAttribute("data-zoom-gallery");
                    t.push({
                        href: i,
                        type: "image"
                    })
                })), t
            },
            initZoomGallery: function(e) {
                return C()({
                    elements: e,
                    autoplayVideos: !0
                })
            },
            findGalleryIndex: function(e) {
                return this.zoomGallery.elements.find((function(t) {
                    return t.href === e
                })).index
            },
            buildZoomHoverEffect: function(e, t) {
                void 0 !== e && e.forEach((function(e) {
                    new S(e, {
                        sourceAttribute: "data-zoom-gallery",
                        paneContainer: t,
                        inlinePane: 900,
                        inlineOffsetY: 0,
                        containInline: !1,
                        hoverBoundingBox: !0
                    })
                }))
            }
        };
        var A = function(e) {
            var t = e,
                i = t.querySelectorAll(".product__image-zoom-img");
            new _(t, i)
        };
        window.theme = window.theme || {}, window.theme.scripts = window.theme.scripts || {}, window.theme.scripts.image_zoom = window.theme.scripts.image_zoom || {}, window.theme.scripts.image_zoom.init = A
    }
});